import type { HeroComboBoxOption } from "@app/components/hero-combobox";

const destinationCatalog: HeroComboBoxOption[] = [
  {
    id: "abe",
    label: "Allentown, US",
    code: "ABE",
    description: "Lehigh Valley International Airport",
    type: "AIRPORT",
  },
  {
    id: "abi",
    label: "Abilene, US",
    code: "ABI",
    description: "Abilene Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "abj",
    label: "Abidjan, CI",
    code: "ABJ",
    description: "Port Bouet Airport",
    type: "AIRPORT",
  },
  {
    id: "abq",
    label: "Albuquerque, US",
    code: "ABQ",
    description: "Albuquerque International Sunport Airport",
    type: "AIRPORT",
  },
  {
    id: "abv",
    label: "Abuja, NG",
    code: "ABV",
    description: "Nnamdi Azikiwe International Airport",
    type: "AIRPORT",
  },
  {
    id: "abx",
    label: "Albury, AU",
    code: "ABX",
    description: "Albury Airport",
    type: "AIRPORT",
  },
  {
    id: "abz",
    label: "Aberdeen, GB",
    code: "ABZ",
    description: "Aberdeen Dyce Airport",
    type: "AIRPORT",
  },
  {
    id: "aca",
    label: "Acapulco, MX",
    code: "ACA",
    description: "General Juan N. Álvarez International Airport",
    type: "AIRPORT",
  },
  {
    id: "acc",
    label: "Accra, GH",
    code: "ACC",
    description: "Kotoka International Airport",
    type: "AIRPORT",
  },
  {
    id: "ace",
    label: "Lanzarote Island, ES",
    code: "ACE",
    description: "Lanzarote Airport",
    type: "AIRPORT",
  },
  {
    id: "ack",
    label: "Nantucket, US",
    code: "ACK",
    description: "Nantucket Memorial Airport",
    type: "AIRPORT",
  },
  {
    id: "act",
    label: "Waco, US",
    code: "ACT",
    description: "Waco Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "acv",
    label: "Arcata/Eureka, US",
    code: "ACV",
    description: "California Redwood Coast-Humboldt County Airport",
    type: "AIRPORT",
  },
  {
    id: "add",
    label: "Addis Ababa, ET",
    code: "ADD",
    description: "Bole International Airport",
    type: "AIRPORT",
  },
  {
    id: "adj",
    label: "Amman, JO",
    code: "ADJ",
    description: "Amman Civil Airport",
    type: "AIRPORT",
  },
  {
    id: "adk",
    label: "Adak Island, US",
    code: "ADK",
    description: "Adak Airport",
    type: "AIRPORT",
  },
  {
    id: "adl",
    label: "Adelaide, AU",
    code: "ADL",
    description: "Adelaide International Airport",
    type: "AIRPORT",
  },
  {
    id: "adq",
    label: "Kodiak, US",
    code: "ADQ",
    description: "Kodiak Airport",
    type: "AIRPORT",
  },
  {
    id: "aer",
    label: "Sochi, RU",
    code: "AER",
    description: "Sochi International Airport",
    type: "AIRPORT",
  },
  {
    id: "aex",
    label: "Alexandria, US",
    code: "AEX",
    description: "Alexandria International Airport",
    type: "AIRPORT",
  },
  {
    id: "aga",
    label: "Agadir, MA",
    code: "AGA",
    description: "Al Massira Airport",
    type: "AIRPORT",
  },
  {
    id: "agp",
    label: "Malaga, ES",
    code: "AGP",
    description: "Malaga Airport",
    type: "AIRPORT",
  },
  {
    id: "ags",
    label: "Augusta, US",
    code: "AGS",
    description: "Augusta Regional At Bush Field",
    type: "AIRPORT",
  },
  {
    id: "agu",
    label: "Aguascalientes, MX",
    code: "AGU",
    description: "Aguascalientes International Airport",
    type: "AIRPORT",
  },
  {
    id: "ahb",
    label: "Abha, SA",
    code: "AHB",
    description: "Abha Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "ahu",
    label: "Al Hoceima, MA",
    code: "AHU",
    description: "Cherif Al Idrissi Airport",
    type: "AIRPORT",
  },
  {
    id: "akj",
    label: "Asahikawa, JP",
    code: "AKJ",
    description: "Asahikawa Airport",
    type: "AIRPORT",
  },
  {
    id: "akl",
    label: "Auckland, NZ",
    code: "AKL",
    description: "Auckland International Airport",
    type: "AIRPORT",
  },
  {
    id: "akn",
    label: "King Salmon, US",
    code: "AKN",
    description: "King Salmon Airport",
    type: "AIRPORT",
  },
  {
    id: "ala",
    label: "Almaty, KZ",
    code: "ALA",
    description: "Almaty International Airport",
    type: "AIRPORT",
  },
  {
    id: "alb",
    label: "Albany, US",
    code: "ALB",
    description: "Albany International Airport",
    type: "AIRPORT",
  },
  {
    id: "alc",
    label: "Alicante, ES",
    code: "ALC",
    description: "Alicante International Airport",
    type: "AIRPORT",
  },
  {
    id: "alf",
    label: "Alta, NO",
    code: "ALF",
    description: "Alta Airport",
    type: "AIRPORT",
  },
  {
    id: "alg",
    label: "Algiers, DZ",
    code: "ALG",
    description: "Houari Boumediene Airport",
    type: "AIRPORT",
  },
  {
    id: "alo",
    label: "Waterloo, US",
    code: "ALO",
    description: "Waterloo Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "alp",
    label: "Aleppo, SY",
    code: "ALP",
    description: "Aleppo International Airport",
    type: "AIRPORT",
  },
  {
    id: "alw",
    label: "Walla Walla, US",
    code: "ALW",
    description: "Walla Walla Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "aly",
    label: "Alexandria, EG",
    code: "ALY",
    description: "Borg El Arab International Airport",
    type: "AIRPORT",
  },
  {
    id: "ama",
    label: "Amarillo, US",
    code: "AMA",
    description: "Rick Husband Amarillo International Airport",
    type: "AIRPORT",
  },
  {
    id: "amd",
    label: "Ahmedabad, IN",
    code: "AMD",
    description: "Sardar Vallabhbhai Patel International Airport",
    type: "AIRPORT",
  },
  {
    id: "amm",
    label: "Amman, JO",
    code: "AMM",
    description: "Queen Alia International Airport",
    type: "AIRPORT",
  },
  {
    id: "ams",
    label: "Amsterdam, NL",
    code: "AMS",
    description: "Amsterdam Airport Schiphol",
    type: "AIRPORT",
  },
  {
    id: "anc",
    label: "Anchorage, US",
    code: "ANC",
    description: "Ted Stevens Anchorage International Airport",
    type: "AIRPORT",
  },
  {
    id: "anu",
    label: "St. George, AG",
    code: "ANU",
    description: "V.C. Bird International Airport",
    type: "AIRPORT",
  },
  {
    id: "aoj",
    label: "Aomori, JP",
    code: "AOJ",
    description: "Aomori Airport",
    type: "AIRPORT",
  },
  {
    id: "aor",
    label: "Alor Satar, MY",
    code: "AOR",
    description: "Sultan Abdul Halim Airport",
    type: "AIRPORT",
  },
  {
    id: "apf",
    label: "Naples, US",
    code: "APF",
    description: "Naples Airport",
    type: "AIRPORT",
  },
  {
    id: "apw",
    label: "Apia, WS",
    code: "APW",
    description: "Faleolo International Airport",
    type: "AIRPORT",
  },
  {
    id: "aqj",
    label: "Aqaba, JO",
    code: "AQJ",
    description: "Aqaba King Hussein International Airport",
    type: "AIRPORT",
  },
  {
    id: "arm",
    label: "Armidale, AU",
    code: "ARM",
    description: "Armidale Airport",
    type: "AIRPORT",
  },
  {
    id: "arn",
    label: "Stockholm, SE",
    code: "ARN",
    description: "Stockholm-Arlanda Airport",
    type: "AIRPORT",
  },
  {
    id: "art",
    label: "Watertown, US",
    code: "ART",
    description: "Watertown International Airport",
    type: "AIRPORT",
  },
  {
    id: "ase",
    label: "Aspen, US",
    code: "ASE",
    description: "Aspen/Pitkin County Airport",
    type: "AIRPORT",
  },
  {
    id: "asj",
    label: "Amami, JP",
    code: "ASJ",
    description: "Amami Airport",
    type: "AIRPORT",
  },
  {
    id: "asp",
    label: "Alice Springs, AU",
    code: "ASP",
    description: "Alice Springs Airport",
    type: "AIRPORT",
  },
  {
    id: "ath",
    label: "Athens, GR",
    code: "ATH",
    description: "Eleftherios Venizelos International Airport",
    type: "AIRPORT",
  },
  {
    id: "atl",
    label: "Atlanta, US",
    code: "ATL",
    description: "Hartsfield/Jackson Atlanta International Airport",
    type: "AIRPORT",
  },
  {
    id: "atq",
    label: "Amritsar, IN",
    code: "ATQ",
    description: "Sri Guru Ram Dass Jee International Airport Amritsar",
    type: "AIRPORT",
  },
  {
    id: "atw",
    label: "Appleton, US",
    code: "ATW",
    description: "Appleton International Airport",
    type: "AIRPORT",
  },
  {
    id: "aua",
    label: "Oranjestad, AW",
    code: "AUA",
    description: "Queen Beatrix International Airport",
    type: "AIRPORT",
  },
  {
    id: "auh",
    label: "Abu Dhabi, AE",
    code: "AUH",
    description: "Abu Dhabi International Airport",
    type: "AIRPORT",
  },
  {
    id: "aus",
    label: "Austin, US",
    code: "AUS",
    description: "Austin-Bergstrom International Airport",
    type: "AIRPORT",
  },
  {
    id: "avl",
    label: "Asheville, US",
    code: "AVL",
    description: "Asheville Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "avp",
    label: "Wilkes-Barre/Scranton, US",
    code: "AVP",
    description: "Wilkes-Barre/Scranton International Airport",
    type: "AIRPORT",
  },
  {
    id: "axa",
    label: "Anguilla, AI",
    code: "AXA",
    description: "Clayton J. Lloyd International Airport",
    type: "AIRPORT",
  },
  {
    id: "axt",
    label: "Akita, JP",
    code: "AXT",
    description: "Akita Airport",
    type: "AIRPORT",
  },
  {
    id: "ayq",
    label: "Ayers Rock, AU",
    code: "AYQ",
    description: "Ayers Rock Connellan Airport",
    type: "AIRPORT",
  },
  {
    id: "ayt",
    label: "Antalya, TR",
    code: "AYT",
    description: "Antalya International Airport",
    type: "AIRPORT",
  },
  {
    id: "azo",
    label: "Kalamazoo/Battle Creek, US",
    code: "AZO",
    description: "Kalamazoo/Battle Creek International Airport",
    type: "AIRPORT",
  },
  {
    id: "bah",
    label: "Manama, BH",
    code: "BAH",
    description: "Bahrain International Airport",
    type: "AIRPORT",
  },
  {
    id: "baq",
    label: "Barranquilla, CO",
    code: "BAQ",
    description: "Ernesto Cortissoz International Airport",
    type: "AIRPORT",
  },
  {
    id: "bci",
    label: "Barcaldine, AU",
    code: "BCI",
    description: "Barcaldine Airport",
    type: "AIRPORT",
  },
  {
    id: "bcn",
    label: "Barcelona, ES",
    code: "BCN",
    description: "Barcelona International Airport",
    type: "AIRPORT",
  },
  {
    id: "bda",
    label: "Hamilton, BM",
    code: "BDA",
    description: "L.F. Wade International International Airport",
    type: "AIRPORT",
  },
  {
    id: "bdb",
    label: "Bundaberg, AU",
    code: "BDB",
    description: "Bundaberg Airport",
    type: "AIRPORT",
  },
  {
    id: "bdl",
    label: "Windsor Locks, US",
    code: "BDL",
    description: "Bradley International Airport",
    type: "AIRPORT",
  },
  {
    id: "bds",
    label: "Brindisi, IT",
    code: "BDS",
    description: "Brindisi / Casale Airport",
    type: "AIRPORT",
  },
  {
    id: "beg",
    label: "Belgrad, RS",
    code: "BEG",
    description: "Belgrade Nikola Tesla Airport",
    type: "AIRPORT",
  },
  {
    id: "ben",
    label: "Benghazi, LY",
    code: "BEN",
    description: "Benina International Airport",
    type: "AIRPORT",
  },
  {
    id: "ber",
    label: "Berlin, DE",
    code: "BER",
    description: "Berlin Brandenburg Airport",
    type: "AIRPORT",
  },
  {
    id: "bet",
    label: "Bethel, US",
    code: "BET",
    description: "Bethel Airport",
    type: "AIRPORT",
  },
  {
    id: "bey",
    label: "Beirut, LB",
    code: "BEY",
    description: "Beirut Rafic Hariri International Airport",
    type: "AIRPORT",
  },
  {
    id: "bfi",
    label: "Seattle, US",
    code: "BFI",
    description: "Boeing Field/King County International Airport",
    type: "AIRPORT",
  },
  {
    id: "bfl",
    label: "Bakersfield, US",
    code: "BFL",
    description: "Meadows Field",
    type: "AIRPORT",
  },
  {
    id: "bgf",
    label: "Bangui, CF",
    code: "BGF",
    description: "Bangui M'Poko International Airport",
    type: "AIRPORT",
  },
  {
    id: "bgi",
    label: "Bridgetown, BB",
    code: "BGI",
    description: "Sir Grantley Adams International Airport",
    type: "AIRPORT",
  },
  {
    id: "bgo",
    label: "Bergen, NO",
    code: "BGO",
    description: "Bergen Airport Flesland",
    type: "AIRPORT",
  },
  {
    id: "bgr",
    label: "Bangor, US",
    code: "BGR",
    description: "Bangor International Airport",
    type: "AIRPORT",
  },
  {
    id: "bgw",
    label: "Baghdad, IQ",
    code: "BGW",
    description: "Baghdad International Airport",
    type: "AIRPORT",
  },
  {
    id: "bhd",
    label: "Belfast, GB",
    code: "BHD",
    description: "George Best Belfast City Airport",
    type: "AIRPORT",
  },
  {
    id: "bhm",
    label: "Birmingham, US",
    code: "BHM",
    description: "Birmingham-Shuttlesworth International Airport",
    type: "AIRPORT",
  },
  {
    id: "bhq",
    label: "Broken Hill, AU",
    code: "BHQ",
    description: "Broken Hill Airport",
    type: "AIRPORT",
  },
  {
    id: "bhx",
    label: "Birmingham, GB",
    code: "BHX",
    description: "Birmingham International Airport",
    type: "AIRPORT",
  },
  {
    id: "bil",
    label: "Billings, US",
    code: "BIL",
    description: "Billings Logan International Airport",
    type: "AIRPORT",
  },
  {
    id: "bim",
    label: "Bimini, BS",
    code: "BIM",
    description: "South Bimini Airport",
    type: "AIRPORT",
  },
  {
    id: "bio",
    label: "Bilbao, ES",
    code: "BIO",
    description: "Bilbao Airport",
    type: "AIRPORT",
  },
  {
    id: "bis",
    label: "Bismarck, US",
    code: "BIS",
    description: "Bismarck Municipal Airport",
    type: "AIRPORT",
  },
  {
    id: "bjl",
    label: "Banjul, GM",
    code: "BJL",
    description: "Banjul International Airport",
    type: "AIRPORT",
  },
  {
    id: "bjv",
    label: "Bodrum, TR",
    code: "BJV",
    description: "Milas Bodrum International Airport",
    type: "AIRPORT",
  },
  {
    id: "bjx",
    label: "Silao, MX",
    code: "BJX",
    description: "Del Bajio International Airport",
    type: "AIRPORT",
  },
  {
    id: "bjz",
    label: "Badajoz, ES",
    code: "BJZ",
    description: "Badajoz Airport",
    type: "AIRPORT",
  },
  {
    id: "bki",
    label: "Kota Kinabalu, MY",
    code: "BKI",
    description: "Kota Kinabalu International Airport",
    type: "AIRPORT",
  },
  {
    id: "bkk",
    label: "Bangkok, TH",
    code: "BKK",
    description: "Suvarnabhumi Airport",
    type: "AIRPORT",
  },
  {
    id: "bko",
    label: "Senou, ML",
    code: "BKO",
    description: "Senou Airport",
    type: "AIRPORT",
  },
  {
    id: "bkq",
    label: "Blackall, AU",
    code: "BKQ",
    description: "Blackall Airport",
    type: "AIRPORT",
  },
  {
    id: "bli",
    label: "Bellingham, US",
    code: "BLI",
    description: "Bellingham International Airport",
    type: "AIRPORT",
  },
  {
    id: "bll",
    label: "Billund, DK",
    code: "BLL",
    description: "Billund Airport",
    type: "AIRPORT",
  },
  {
    id: "blq",
    label: "Bologna, IT",
    code: "BLQ",
    description: "Bologna / Borgo Panigale Airport",
    type: "AIRPORT",
  },
  {
    id: "blr",
    label: "Bangalore, IN",
    code: "BLR",
    description: "Bengaluru International Airport",
    type: "AIRPORT",
  },
  {
    id: "bme",
    label: "Broome, AU",
    code: "BME",
    description: "Broome International Airport",
    type: "AIRPORT",
  },
  {
    id: "bmi",
    label: "Bloomington/Normal, US",
    code: "BMI",
    description: "Central Illinois Regional Airport at Bloomington-Normal",
    type: "AIRPORT",
  },
  {
    id: "bna",
    label: "Nashville, US",
    code: "BNA",
    description: "Nashville International Airport",
    type: "AIRPORT",
  },
  {
    id: "bne",
    label: "Brisbane, AU",
    code: "BNE",
    description: "Brisbane International Airport",
    type: "AIRPORT",
  },
  {
    id: "bnk",
    label: "Ballina, AU",
    code: "BNK",
    description: "Ballina Byron Gateway Airport",
    type: "AIRPORT",
  },
  {
    id: "bod",
    label: "Bordeaux/Merignac, FR",
    code: "BOD",
    description: "Bordeaux-Merignac (BA 106) Airport",
    type: "AIRPORT",
  },
  {
    id: "bog",
    label: "Bogota, CO",
    code: "BOG",
    description: "El Dorado International Airport",
    type: "AIRPORT",
  },
  {
    id: "boi",
    label: "Boise, US",
    code: "BOI",
    description: "Boise Air Trml/Gowen Field",
    type: "AIRPORT",
  },
  {
    id: "bom",
    label: "Mumbai, IN",
    code: "BOM",
    description: "Chhatrapati Shivaji International Airport",
    type: "AIRPORT",
  },
  {
    id: "bon",
    label: "Kralendijk, BQ",
    code: "BON",
    description: "Flamingo International Airport",
    type: "AIRPORT",
  },
  {
    id: "boo",
    label: "Bodo, NO",
    code: "BOO",
    description: "Bodø Airport",
    type: "AIRPORT",
  },
  {
    id: "bos",
    label: "Boston, US",
    code: "BOS",
    description: "General Edward Lawrence Logan International Airport",
    type: "AIRPORT",
  },
  {
    id: "bpn",
    label: "Balikpapan, Borneo Island, ID",
    code: "BPN",
    description: "Sepinggan International Airport",
    type: "AIRPORT",
  },
  {
    id: "bpt",
    label: "Beaumont/Port Arthur, US",
    code: "BPT",
    description: "Jack Brooks Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "bri",
    label: "Bari, IT",
    code: "BRI",
    description: "Bari Karol Wojtyła Airport",
    type: "AIRPORT",
  },
  {
    id: "brk",
    label: "Bourke, AU",
    code: "BRK",
    description: "Bourke Airport",
    type: "AIRPORT",
  },
  {
    id: "bro",
    label: "Brownsville, US",
    code: "BRO",
    description: "Brownsville/South Padre Island International Airport",
    type: "AIRPORT",
  },
  {
    id: "bru",
    label: "Brussels, BE",
    code: "BRU",
    description: "Brussels Airport",
    type: "AIRPORT",
  },
  {
    id: "brw",
    label: "Utqiagvik, US",
    code: "BRW",
    description: "Wiley Post-Will Rogers Memorial Airport",
    type: "AIRPORT",
  },
  {
    id: "bsl",
    label: "Bale/Mulhouse, CH",
    code: "BSL",
    description: "EuroAirport Basel-Mulhouse-Freiburg Airport",
    type: "AIRPORT",
  },
  {
    id: "bsr",
    label: "Basrah, IQ",
    code: "BSR",
    description: "Basrah International Airport",
    type: "AIRPORT",
  },
  {
    id: "btr",
    label: "Baton Rouge, US",
    code: "BTR",
    description: "Baton Rouge Metropolitan Airport",
    type: "AIRPORT",
  },
  {
    id: "btu",
    label: "Bintulu, MY",
    code: "BTU",
    description: "Bintulu Airport",
    type: "AIRPORT",
  },
  {
    id: "btv",
    label: "Burlington, US",
    code: "BTV",
    description: "Patrick Leahy Burlington International Airport",
    type: "AIRPORT",
  },
  {
    id: "bud",
    label: "Budapest, HU",
    code: "BUD",
    description: "Budapest Ferenc Liszt International Airport",
    type: "AIRPORT",
  },
  {
    id: "buf",
    label: "Buffalo, US",
    code: "BUF",
    description: "Buffalo Niagara International Airport",
    type: "AIRPORT",
  },
  {
    id: "bur",
    label: "Burbank, US",
    code: "BUR",
    description: "Bob Hope Airport",
    type: "AIRPORT",
  },
  {
    id: "bwi",
    label: "Baltimore, US",
    code: "BWI",
    description: "Baltimore/Washington International Thurgood Marshall Airport",
    type: "AIRPORT",
    parentMetroCode: "WAS",
  },
  {
    id: "bwt",
    label: "Burnie, AU",
    code: "BWT",
    description: "Burnie Airport",
    type: "AIRPORT",
  },
  {
    id: "bxg",
    label: "Bendigo, AU",
    code: "BXG",
    description: "Bendigo Airport",
    type: "AIRPORT",
  },
  {
    id: "bze",
    label: "Belize City, BZ",
    code: "BZE",
    description: "Philip S. W. Goldson International Airport",
    type: "AIRPORT",
  },
  {
    id: "bzn",
    label: "Bozeman, US",
    code: "BZN",
    description: "Bozeman Yellowstone International Airport",
    type: "AIRPORT",
  },
  {
    id: "bzv",
    label: "Brazzaville, CG",
    code: "BZV",
    description: "Maya-Maya Airport",
    type: "AIRPORT",
  },
  {
    id: "cae",
    label: "Columbia, US",
    code: "CAE",
    description: "Columbia Metro Airport",
    type: "AIRPORT",
  },
  {
    id: "cag",
    label: "Cagliari, IT",
    code: "CAG",
    description: "Cagliari / Elmas Airport",
    type: "AIRPORT",
  },
  {
    id: "cai",
    label: "Cairo, EG",
    code: "CAI",
    description: "Cairo International Airport",
    type: "AIRPORT",
  },
  {
    id: "cak",
    label: "Akron/Canton, US",
    code: "CAK",
    description: "Akron-Canton Airport",
    type: "AIRPORT",
  },
  {
    id: "can",
    label: "Guangzhou, CN",
    code: "CAN",
    description: "Guangzhou Baiyun International Airport",
    type: "AIRPORT",
  },
  {
    id: "cap",
    label: "Cap-Haitien, HT",
    code: "CAP",
    description: "Cap-Haïtien International Airport",
    type: "AIRPORT",
  },
  {
    id: "cbr",
    label: "Canberra, AU",
    code: "CBR",
    description: "Canberra International Airport",
    type: "AIRPORT",
  },
  {
    id: "ccj",
    label: "Calicut, IN",
    code: "CCJ",
    description: "Calicut International Airport",
    type: "AIRPORT",
  },
  {
    id: "cck",
    label: "Cocos Islands, CC",
    code: "CCK",
    description: "Cocos (Keeling) Islands Airport",
    type: "AIRPORT",
  },
  {
    id: "ccs",
    label: "Caracas, VE",
    code: "CCS",
    description: "Maiquetia (Simon Bolivar Internacional) Airport",
    type: "AIRPORT",
  },
  {
    id: "ccu",
    label: "Kolkata, IN",
    code: "CCU",
    description: "Netaji Subhash Chandra Bose International Airport",
    type: "AIRPORT",
  },
  {
    id: "cdg",
    label: "Paris, FR",
    code: "CDG",
    description: "Charles de Gaulle International Airport",
    type: "AIRPORT",
    parentMetroCode: "PAR",
  },
  {
    id: "cdt",
    label: "Castellon de la Plana, ES",
    code: "CDT",
    description: "Castellón–Costa Azahar Airport",
    type: "AIRPORT",
  },
  {
    id: "cdv",
    label: "Cordova, US",
    code: "CDV",
    description: "Merle K (Mudhole) Smith Airport",
    type: "AIRPORT",
  },
  {
    id: "ceb",
    label: "Lapu-Lapu City, PH",
    code: "CEB",
    description: "Mactan Cebu International Airport",
    type: "AIRPORT",
  },
  {
    id: "cfs",
    label: "Coffs Harbour, AU",
    code: "CFS",
    description: "Coffs Harbour Airport",
    type: "AIRPORT",
  },
  {
    id: "cfu",
    label: "Kerkyra Island, GR",
    code: "CFU",
    description: "Ioannis Kapodistrias International Airport",
    type: "AIRPORT",
  },
  {
    id: "cgk",
    label: "Jakarta, ID",
    code: "CGK",
    description: "Soekarno-Hatta International Airport",
    type: "AIRPORT",
  },
  {
    id: "cgn",
    label: "Cologne, DE",
    code: "CGN",
    description: "Cologne Bonn Airport",
    type: "AIRPORT",
  },
  {
    id: "cgo",
    label: "Zhengzhou, CN",
    code: "CGO",
    description: "Xinzheng Airport",
    type: "AIRPORT",
  },
  {
    id: "cha",
    label: "Chattanooga, US",
    code: "CHA",
    description: "Lovell Field",
    type: "AIRPORT",
  },
  {
    id: "chc",
    label: "Christchurch, NZ",
    code: "CHC",
    description: "Christchurch International Airport",
    type: "AIRPORT",
  },
  {
    id: "cho",
    label: "Charlottesville, US",
    code: "CHO",
    description: "Charlottesville–Albemarle Airport",
    type: "AIRPORT",
  },
  {
    id: "chq",
    label: "Souda, GR",
    code: "CHQ",
    description: "Chania International Airport",
    type: "AIRPORT",
  },
  {
    id: "chs",
    label: "Charleston, US",
    code: "CHS",
    description: "Charleston Afb/International Airport",
    type: "AIRPORT",
  },
  {
    id: "cid",
    label: "Cedar Rapids, US",
    code: "CID",
    description: "The Eastern Iowa Airport",
    type: "AIRPORT",
  },
  {
    id: "cjb",
    label: "Coimbatore, IN",
    code: "CJB",
    description: "Coimbatore International Airport",
    type: "AIRPORT",
  },
  {
    id: "ckg",
    label: "Chongqing, CN",
    code: "CKG",
    description: "Chongqing Jiangbei International Airport",
    type: "AIRPORT",
  },
  {
    id: "cky",
    label: "Conakry, GN",
    code: "CKY",
    description: "Conakry Airport",
    type: "AIRPORT",
  },
  {
    id: "cld",
    label: "San Diego, US",
    code: "CLD",
    description: "McClellan–Palomar Airport",
    type: "AIRPORT",
  },
  {
    id: "cle",
    label: "Cleveland, US",
    code: "CLE",
    description: "Cleveland-Hopkins International Airport",
    type: "AIRPORT",
  },
  {
    id: "cll",
    label: "College Station, US",
    code: "CLL",
    description: "Easterwood Airport",
    type: "AIRPORT",
  },
  {
    id: "clo",
    label: "Cali, CO",
    code: "CLO",
    description: "Alfonso Bonilla Aragon International Airport",
    type: "AIRPORT",
  },
  {
    id: "clt",
    label: "Charlotte, US",
    code: "CLT",
    description: "Charlotte/Douglas International Airport",
    type: "AIRPORT",
  },
  {
    id: "cmb",
    label: "Colombo, LK",
    code: "CMB",
    description: "Bandaranaike International Apt Colombo Airport",
    type: "AIRPORT",
  },
  {
    id: "cmf",
    label: "Chambery/Aix-les-Bains, FR",
    code: "CMF",
    description: "Chambéry Airport",
    type: "AIRPORT",
  },
  {
    id: "cmh",
    label: "Columbus, US",
    code: "CMH",
    description: "John Glenn Columbus International Airport",
    type: "AIRPORT",
  },
  {
    id: "cmi",
    label: "Champaign/Urbana, US",
    code: "CMI",
    description: "University of Illinois Willard Airport",
    type: "AIRPORT",
  },
  {
    id: "cmn",
    label: "Casablanca, MA",
    code: "CMN",
    description: "Mohammed V International Airport",
    type: "AIRPORT",
  },
  {
    id: "cmw",
    label: "Camaguey, CU",
    code: "CMW",
    description: "Ignacio Agramonte International Airport",
    type: "AIRPORT",
  },
  {
    id: "cnj",
    label: "Cloncurry, AU",
    code: "CNJ",
    description: "Cloncurry Airport",
    type: "AIRPORT",
  },
  {
    id: "cns",
    label: "Cairns, AU",
    code: "CNS",
    description: "Cairns International Airport",
    type: "AIRPORT",
  },
  {
    id: "cnx",
    label: "Chiang Mai, TH",
    code: "CNX",
    description: "Chiang Mai International Airport",
    type: "AIRPORT",
  },
  {
    id: "cok",
    label: "Cochin, IN",
    code: "COK",
    description: "Cochin International Airport",
    type: "AIRPORT",
  },
  {
    id: "coo",
    label: "Cotonou, BJ",
    code: "COO",
    description: "Cadjehoun Airport",
    type: "AIRPORT",
  },
  {
    id: "cos",
    label: "Colorado Springs, US",
    code: "COS",
    description: "City Of Colorado Springs Municipal Airport",
    type: "AIRPORT",
  },
  {
    id: "cou",
    label: "Columbia, US",
    code: "COU",
    description: "Columbia Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "cph",
    label: "Copenhagen, DK",
    code: "CPH",
    description: "Copenhagen Kastrup Airport",
    type: "AIRPORT",
  },
  {
    id: "cpt",
    label: "Cape Town, ZA",
    code: "CPT",
    description: "Cape Town International Airport",
    type: "AIRPORT",
  },
  {
    id: "crk",
    label: "Angeles City, PH",
    code: "CRK",
    description: "Diosdado Macapagal International Airport",
    type: "AIRPORT",
  },
  {
    id: "crp",
    label: "Corpus Christi, US",
    code: "CRP",
    description: "Corpus Christi International Airport",
    type: "AIRPORT",
  },
  {
    id: "crw",
    label: "Charleston, US",
    code: "CRW",
    description: "West Virginia International Yeager Airport",
    type: "AIRPORT",
  },
  {
    id: "csx",
    label: "Changsha, CN",
    code: "CSX",
    description: "Changsha Huanghua Airport",
    type: "AIRPORT",
  },
  {
    id: "cta",
    label: "Catania, IT",
    code: "CTA",
    description: "Catania / Fontanarossa Airport",
    type: "AIRPORT",
  },
  {
    id: "ctg",
    label: "Cartagena, CO",
    code: "CTG",
    description: "Rafael Nunez International Airport",
    type: "AIRPORT",
  },
  {
    id: "cts",
    label: "Chitose / Tomakomai, JP",
    code: "CTS",
    description: "New Chitose Airport",
    type: "AIRPORT",
  },
  {
    id: "ctu",
    label: "Chengdu, CN",
    code: "CTU",
    description: "Chengdu Shuangliu International Airport",
    type: "AIRPORT",
  },
  {
    id: "cun",
    label: "Cancun, MX",
    code: "CUN",
    description: "Cancun International Airport",
    type: "AIRPORT",
  },
  {
    id: "cur",
    label: "Willemstad, CW",
    code: "CUR",
    description: "Hato International Airport",
    type: "AIRPORT",
  },
  {
    id: "cuu",
    label: "Chihuahua, MX",
    code: "CUU",
    description: "Chihuahua International Airport",
    type: "AIRPORT",
  },
  {
    id: "cvg",
    label: "Covington, US",
    code: "CVG",
    description: "Cincinnati/Northern Kentucky International Airport",
    type: "AIRPORT",
  },
  {
    id: "cwa",
    label: "Wausau, US",
    code: "CWA",
    description: "Central Wisconsin Airport",
    type: "AIRPORT",
  },
  {
    id: "cxi",
    label: "Banana, KI",
    code: "CXI",
    description: "Cassidy International Airport",
    type: "AIRPORT",
  },
  {
    id: "czm",
    label: "Cozumel, MX",
    code: "CZM",
    description: "Cozumel International Airport",
    type: "AIRPORT",
  },
  {
    id: "dab",
    label: "Daytona Beach, US",
    code: "DAB",
    description: "Daytona Beach International Airport",
    type: "AIRPORT",
  },
  {
    id: "dac",
    label: "Dhaka, BD",
    code: "DAC",
    description: "Dhaka / Hazrat Shahjalal International Airport",
    type: "AIRPORT",
  },
  {
    id: "dad",
    label: "Da Nang, VN",
    code: "DAD",
    description: "Da Nang International Airport",
    type: "AIRPORT",
  },
  {
    id: "dam",
    label: "Damascus, SY",
    code: "DAM",
    description: "Damascus International Airport",
    type: "AIRPORT",
  },
  {
    id: "dar",
    label: "Dar es Salaam, TZ",
    code: "DAR",
    description: "Mwalimu Julius K. Nyerere International Airport",
    type: "AIRPORT",
  },
  {
    id: "day",
    label: "Dayton, US",
    code: "DAY",
    description: "James M. Cox Dayton International Airport",
    type: "AIRPORT",
  },
  {
    id: "dbo",
    label: "Dubbo, AU",
    code: "DBO",
    description: "Dubbo Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "dbv",
    label: "Dubrovnik, HR",
    code: "DBV",
    description: "Dubrovnik Airport",
    type: "AIRPORT",
  },
  {
    id: "dca",
    label: "Washington, US",
    code: "DCA",
    description: "Ronald Reagan Washington Ntl Airport",
    type: "AIRPORT",
    parentMetroCode: "WAS",
  },
  {
    id: "del",
    label: "New Delhi, IN",
    code: "DEL",
    description: "Indira Gandhi International Airport",
    type: "AIRPORT",
  },
  {
    id: "den",
    label: "Denver, US",
    code: "DEN",
    description: "Denver International Airport",
    type: "AIRPORT",
  },
  {
    id: "dfw",
    label: "Dallas-Fort Worth, US",
    code: "DFW",
    description: "Dallas-Fort Worth International Airport",
    type: "AIRPORT",
  },
  {
    id: "dgo",
    label: "Durango, MX",
    code: "DGO",
    description: "General Guadalupe Victoria International Airport",
    type: "AIRPORT",
  },
  {
    id: "dil",
    label: "Dili, TL",
    code: "DIL",
    description: "Presidente Nicolau Lobato International Airport",
    type: "AIRPORT",
  },
  {
    id: "djt",
    label: "West Palm Beach, US",
    code: "DJT",
    description: "President Donald J. Trump International Airport",
    type: "AIRPORT",
  },
  {
    id: "dla",
    label: "Douala, CM",
    code: "DLA",
    description: "Douala International Airport",
    type: "AIRPORT",
  },
  {
    id: "dlc",
    label: "Dalian, CN",
    code: "DLC",
    description: "Zhoushuizi Airport",
    type: "AIRPORT",
  },
  {
    id: "dlg",
    label: "Dillingham, US",
    code: "DLG",
    description: "Dillingham Airport",
    type: "AIRPORT",
  },
  {
    id: "dlm",
    label: "Dalaman, TR",
    code: "DLM",
    description: "Dalaman International Airport",
    type: "AIRPORT",
  },
  {
    id: "dme",
    label: "Moscow, RU",
    code: "DME",
    description: "Domodedovo International Airport",
    type: "AIRPORT",
  },
  {
    id: "dmm",
    label: "Ad Dammam, SA",
    code: "DMM",
    description: "King Fahd International Airport",
    type: "AIRPORT",
  },
  {
    id: "doh",
    label: "Doha, QA",
    code: "DOH",
    description: "Hamad International Airport",
    type: "AIRPORT",
  },
  {
    id: "dom",
    label: "Dominica, DM",
    code: "DOM",
    description: "Douglas–Charles Airport",
    type: "AIRPORT",
  },
  {
    id: "dpo",
    label: "Devonport, AU",
    code: "DPO",
    description: "Devonport Airport",
    type: "AIRPORT",
  },
  {
    id: "dps",
    label: "Denpasar-Bali Island, ID",
    code: "DPS",
    description: "Ngurah Rai (Bali) International Airport",
    type: "AIRPORT",
  },
  {
    id: "dro",
    label: "Durango, US",
    code: "DRO",
    description: "Durango-La Plata County Airport",
    type: "AIRPORT",
  },
  {
    id: "drw",
    label: "Darwin, AU",
    code: "DRW",
    description: "Darwin International Airport",
    type: "AIRPORT",
  },
  {
    id: "dsm",
    label: "Des Moines, US",
    code: "DSM",
    description: "Des Moines International Airport",
    type: "AIRPORT",
  },
  {
    id: "dss",
    label: "Diass, SN",
    code: "DSS",
    description: "Blaise Diagne International Airport",
    type: "AIRPORT",
  },
  {
    id: "dtw",
    label: "Detroit, US",
    code: "DTW",
    description: "Detroit Metro Wayne County Airport",
    type: "AIRPORT",
  },
  {
    id: "dub",
    label: "Dublin, IE",
    code: "DUB",
    description: "Dublin Airport",
    type: "AIRPORT",
  },
  {
    id: "dur",
    label: "Durban, ZA",
    code: "DUR",
    description: "King Shaka International Airport",
    type: "AIRPORT",
  },
  {
    id: "dus",
    label: "Dusseldorf, DE",
    code: "DUS",
    description: "Dusseldorf International Airport",
    type: "AIRPORT",
  },
  {
    id: "dvo",
    label: "Davao City, PH",
    code: "DVO",
    description: "Francisco Bangoy International Airport",
    type: "AIRPORT",
  },
  {
    id: "dxb",
    label: "Dubai, AE",
    code: "DXB",
    description: "Dubai International Airport",
    type: "AIRPORT",
  },
  {
    id: "eas",
    label: "Hondarribia, ES",
    code: "EAS",
    description: "San Sebastian Airport",
    type: "AIRPORT",
  },
  {
    id: "eat",
    label: "Wenatchee, US",
    code: "EAT",
    description: "Pangborn Memorial Airport",
    type: "AIRPORT",
  },
  {
    id: "ebb",
    label: "Kampala, UG",
    code: "EBB",
    description: "Entebbe International Airport",
    type: "AIRPORT",
  },
  {
    id: "ebl",
    label: "Arbil, IQ",
    code: "EBL",
    description: "Erbil International Airport",
    type: "AIRPORT",
  },
  {
    id: "ecp",
    label: "Panama City, US",
    code: "ECP",
    description: "Northwest Florida Beaches International Airport",
    type: "AIRPORT",
  },
  {
    id: "edi",
    label: "Edinburgh, GB",
    code: "EDI",
    description: "Edinburgh Airport",
    type: "AIRPORT",
  },
  {
    id: "efl",
    label: "Kefallinia Island, GR",
    code: "EFL",
    description: "Kefallinia Airport",
    type: "AIRPORT",
  },
  {
    id: "egc",
    label: "Bergerac, FR",
    code: "EGC",
    description: "Bergerac Dordogne Périgord Airport",
    type: "AIRPORT",
  },
  {
    id: "ege",
    label: "Eagle, US",
    code: "EGE",
    description: "Eagle County Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "eis",
    label: "Tortola, VG",
    code: "EIS",
    description: "Terrance B. Lettsome International Airport",
    type: "AIRPORT",
  },
  {
    id: "elh",
    label: "North Eleuthera, BS",
    code: "ELH",
    description: "North Eleuthera Airport",
    type: "AIRPORT",
  },
  {
    id: "elp",
    label: "El Paso, US",
    code: "ELP",
    description: "El Paso International Airport",
    type: "AIRPORT",
  },
  {
    id: "elq",
    label: "Gassim, SA",
    code: "ELQ",
    description: "Gassim Airport",
    type: "AIRPORT",
  },
  {
    id: "emd",
    label: "Emerald, AU",
    code: "EMD",
    description: "Emerald Airport",
    type: "AIRPORT",
  },
  {
    id: "erh",
    label: "Errachidia, MA",
    code: "ERH",
    description: "Moulay Ali Cherif Airport",
    type: "AIRPORT",
  },
  {
    id: "eri",
    label: "Erie, US",
    code: "ERI",
    description: "Erie International Airport",
    type: "AIRPORT",
  },
  {
    id: "esb",
    label: "Ankara, TR",
    code: "ESB",
    description: "Esenboga International Airport",
    type: "AIRPORT",
  },
  {
    id: "esu",
    label: "Essaouira, MA",
    code: "ESU",
    description: "Essaouira-Mogador Airport",
    type: "AIRPORT",
  },
  {
    id: "eug",
    label: "Eugene, US",
    code: "EUG",
    description: "Mahlon Sweet Field",
    type: "AIRPORT",
  },
  {
    id: "eun",
    label: "El Aaiun, EH",
    code: "EUN",
    description: "Hassan I Airport",
    type: "AIRPORT",
  },
  {
    id: "evn",
    label: "Yerevan, AM",
    code: "EVN",
    description: "Zvartnots International Airport",
    type: "AIRPORT",
  },
  {
    id: "evv",
    label: "Evansville, US",
    code: "EVV",
    description: "Evansville Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "ewn",
    label: "New Bern, US",
    code: "EWN",
    description: "Coastal Carolina Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "ewr",
    label: "Newark, US",
    code: "EWR",
    description: "Newark Liberty International Airport",
    type: "AIRPORT",
    parentMetroCode: "NYC",
  },
  {
    id: "eyw",
    label: "Key West, US",
    code: "EYW",
    description: "Key West International Airport",
    type: "AIRPORT",
  },
  {
    id: "eze",
    label: "Ezeiza, AR",
    code: "EZE",
    description: "Ministro Pistarini International Airport",
    type: "AIRPORT",
  },
  {
    id: "fab",
    label: "Farnborough, GB",
    code: "FAB",
    description: "Farnborough Airport",
    type: "AIRPORT",
  },
  {
    id: "fai",
    label: "Fairbanks, US",
    code: "FAI",
    description: "Fairbanks International Airport",
    type: "AIRPORT",
  },
  {
    id: "fao",
    label: "Faro, PT",
    code: "FAO",
    description: "Faro Airport",
    type: "AIRPORT",
  },
  {
    id: "far",
    label: "Fargo, US",
    code: "FAR",
    description: "Hector International Airport",
    type: "AIRPORT",
  },
  {
    id: "fat",
    label: "Fresno, US",
    code: "FAT",
    description: "Fresno Yosemite International Airport",
    type: "AIRPORT",
  },
  {
    id: "fay",
    label: "Fayetteville, US",
    code: "FAY",
    description: "Fayetteville Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "fca",
    label: "Kalispell, US",
    code: "FCA",
    description: "Glacier Park International Airport",
    type: "AIRPORT",
  },
  {
    id: "fco",
    label: "Rome, IT",
    code: "FCO",
    description: "Leonardo Da Vinci (Fiumicino) International Airport",
    type: "AIRPORT",
  },
  {
    id: "fdf",
    label: "Fort-de-France, MQ",
    code: "FDF",
    description: "Martinique Aime Cesaire International Airport",
    type: "AIRPORT",
  },
  {
    id: "fez",
    label: "Fes, MA",
    code: "FEZ",
    description: "Saiss Airport",
    type: "AIRPORT",
  },
  {
    id: "fih",
    label: "Kinshasa, CD",
    code: "FIH",
    description: "Ndjili International Airport",
    type: "AIRPORT",
  },
  {
    id: "flg",
    label: "Flagstaff, US",
    code: "FLG",
    description: "Flagstaff Pulliam Airport",
    type: "AIRPORT",
  },
  {
    id: "fll",
    label: "Fort Lauderdale, US",
    code: "FLL",
    description: "Fort Lauderdale/Hollywood International Airport",
    type: "AIRPORT",
  },
  {
    id: "flo",
    label: "Florence, US",
    code: "FLO",
    description: "Florence Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "flr",
    label: "Firenze, IT",
    code: "FLR",
    description: "Firenze / Peretola Airport",
    type: "AIRPORT",
  },
  {
    id: "fna",
    label: "Freetown, SL",
    code: "FNA",
    description: "Lungi International Airport",
    type: "AIRPORT",
  },
  {
    id: "fnc",
    label: "Funchal, PT",
    code: "FNC",
    description: "Madeira Airport",
    type: "AIRPORT",
  },
  {
    id: "fnt",
    label: "Flint, US",
    code: "FNT",
    description: "Bishop International Airport",
    type: "AIRPORT",
  },
  {
    id: "foc",
    label: "Fuzhou, CN",
    code: "FOC",
    description: "Fuzhou Changle International Airport",
    type: "AIRPORT",
  },
  {
    id: "for",
    label: "Fortaleza, BR",
    code: "FOR",
    description: "Pinto Martins International Airport",
    type: "AIRPORT",
  },
  {
    id: "fpo",
    label: "Freeport, BS",
    code: "FPO",
    description: "Grand Bahama International Airport",
    type: "AIRPORT",
  },
  {
    id: "fra",
    label: "Frankfurt am Main, DE",
    code: "FRA",
    description: "Frankfurt am Main International Airport",
    type: "AIRPORT",
  },
  {
    id: "fsc",
    label: "Figari Sud-Corse, FR",
    code: "FSC",
    description: "Figari Sud-Corse Airport",
    type: "AIRPORT",
  },
  {
    id: "fsd",
    label: "Sioux Falls, US",
    code: "FSD",
    description: "Joe Foss Field",
    type: "AIRPORT",
  },
  {
    id: "fsm",
    label: "Fort Smith, US",
    code: "FSM",
    description: "Fort Smith Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "fue",
    label: "Fuerteventura Island, ES",
    code: "FUE",
    description: "Fuerteventura Airport",
    type: "AIRPORT",
  },
  {
    id: "fuk",
    label: "Fukuoka, JP",
    code: "FUK",
    description: "Fukuoka Airport",
    type: "AIRPORT",
  },
  {
    id: "fun",
    label: "Funafuti, TV",
    code: "FUN",
    description: "Funafuti International Airport",
    type: "AIRPORT",
  },
  {
    id: "fwa",
    label: "Fort Wayne, US",
    code: "FWA",
    description: "Fort Wayne International Airport",
    type: "AIRPORT",
  },
  {
    id: "gaj",
    label: "Yamagata, JP",
    code: "GAJ",
    description: "Yamagata Airport",
    type: "AIRPORT",
  },
  {
    id: "gan",
    label: "Gan, MV",
    code: "GAN",
    description: "Gan International Airport",
    type: "AIRPORT",
  },
  {
    id: "gci",
    label: "Saint Peter Port, GB",
    code: "GCI",
    description: "Guernsey Airport",
    type: "AIRPORT",
  },
  {
    id: "gck",
    label: "Garden City, US",
    code: "GCK",
    description: "Garden City Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "gcm",
    label: "Georgetown, KY",
    code: "GCM",
    description: "Owen Roberts International Airport",
    type: "AIRPORT",
  },
  {
    id: "gdl",
    label: "Guadalajara, MX",
    code: "GDL",
    description: "Don Miguel Hidalgo Y Costilla International Airport",
    type: "AIRPORT",
  },
  {
    id: "gdn",
    label: "Gdansk, PL",
    code: "GDN",
    description: "Gdańsk Lech Wałęsa Airport",
    type: "AIRPORT",
  },
  {
    id: "geg",
    label: "Spokane, US",
    code: "GEG",
    description: "Spokane International Airport",
    type: "AIRPORT",
  },
  {
    id: "geo",
    label: "Georgetown, GY",
    code: "GEO",
    description: "Cheddi Jagan International Airport",
    type: "AIRPORT",
  },
  {
    id: "get",
    label: "Geraldton, AU",
    code: "GET",
    description: "Geraldton Airport",
    type: "AIRPORT",
  },
  {
    id: "gff",
    label: "Griffith, AU",
    code: "GFF",
    description: "Griffith Airport",
    type: "AIRPORT",
  },
  {
    id: "ggg",
    label: "Longview, US",
    code: "GGG",
    description: "East Texas Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "ggt",
    label: "George Town, BS",
    code: "GGT",
    description: "Exuma International Airport",
    type: "AIRPORT",
  },
  {
    id: "ghb",
    label: "Governor's Harbour, BS",
    code: "GHB",
    description: "Governor's Harbour Airport",
    type: "AIRPORT",
  },
  {
    id: "gib",
    label: "Gibraltar, GI",
    code: "GIB",
    description: "Gibraltar Airport",
    type: "AIRPORT",
  },
  {
    id: "gig",
    label: "Rio De Janeiro, BR",
    code: "GIG",
    description: "Galeao - Antonio Carlos Jobim International Airport",
    type: "AIRPORT",
  },
  {
    id: "gjt",
    label: "Grand Junction, US",
    code: "GJT",
    description: "Grand Junction Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "gla",
    label: "Glasgow, GB",
    code: "GLA",
    description: "Glasgow International Airport",
    type: "AIRPORT",
  },
  {
    id: "gln",
    label: "Guelmim, MA",
    code: "GLN",
    description: "Guelmim Airport",
    type: "AIRPORT",
  },
  {
    id: "glt",
    label: "Gladstone, AU",
    code: "GLT",
    description: "Gladstone Airport",
    type: "AIRPORT",
  },
  {
    id: "gmp",
    label: "Seoul, KR",
    code: "GMP",
    description: "Gimpo International Airport",
    type: "AIRPORT",
    parentMetroCode: "SEL",
  },
  {
    id: "gnb",
    label: "Lyon, FR",
    code: "GNB",
    description: "Grenoble Alpes-Isère Airport",
    type: "AIRPORT",
  },
  {
    id: "gnd",
    label: "Saint George's, GD",
    code: "GND",
    description: "Point Salines International Airport",
    type: "AIRPORT",
  },
  {
    id: "gnv",
    label: "Gainesville, US",
    code: "GNV",
    description: "Gainesville Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "got",
    label: "Gothenburg, SE",
    code: "GOT",
    description: "Gothenburg-Landvetter Airport",
    type: "AIRPORT",
  },
  {
    id: "gox",
    label: "Mopa, IN",
    code: "GOX",
    description: "Manohar International Airport",
    type: "AIRPORT",
  },
  {
    id: "gpt",
    label: "Gulfport/Biloxi, US",
    code: "GPT",
    description: "Gulfport–Biloxi International Airport",
    type: "AIRPORT",
  },
  {
    id: "grb",
    label: "Green Bay, US",
    code: "GRB",
    description: "Green Bay–Austin Straubel International Airport",
    type: "AIRPORT",
  },
  {
    id: "gri",
    label: "Grand Island, US",
    code: "GRI",
    description: "Central Nebraska Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "grk",
    label: "Killeen/Fort Hood, US",
    code: "GRK",
    description: "Killeen Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "gro",
    label: "Gerona, ES",
    code: "GRO",
    description: "Girona–Costa Brava Airport",
    type: "AIRPORT",
  },
  {
    id: "grr",
    label: "Grand Rapids, US",
    code: "GRR",
    description: "Gerald R Ford International Airport",
    type: "AIRPORT",
  },
  {
    id: "gru",
    label: "Sao Paulo, BR",
    code: "GRU",
    description:
      "Guarulhos - Governador Andre Franco Montoro International Airport",
    type: "AIRPORT",
  },
  {
    id: "grx",
    label: "Granada, ES",
    code: "GRX",
    description: "Federico García Lorca Granada Airport",
    type: "AIRPORT",
  },
  {
    id: "grz",
    label: "Graz, AT",
    code: "GRZ",
    description: "Graz Airport",
    type: "AIRPORT",
  },
  {
    id: "gso",
    label: "Greensboro, US",
    code: "GSO",
    description: "Piedmont Triad International Airport",
    type: "AIRPORT",
  },
  {
    id: "gsp",
    label: "Greer, US",
    code: "GSP",
    description: "Greenville Spartanburg International Airport",
    type: "AIRPORT",
  },
  {
    id: "gst",
    label: "Gustavus, US",
    code: "GST",
    description: "Gustavus Airport",
    type: "AIRPORT",
  },
  {
    id: "gtf",
    label: "Great Falls, US",
    code: "GTF",
    description: "Great Falls International Airport",
    type: "AIRPORT",
  },
  {
    id: "gtr",
    label: "Columbus, US",
    code: "GTR",
    description: "Golden Triangle Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "gua",
    label: "Guatemala City, GT",
    code: "GUA",
    description: "La Aurora Airport",
    type: "AIRPORT",
  },
  {
    id: "guc",
    label: "Gunnison, US",
    code: "GUC",
    description: "Gunnison-Crested Butte Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "gum",
    label: "Tamuning, US",
    code: "GUM",
    description: "Guam International Airport",
    type: "AIRPORT",
  },
  {
    id: "gva",
    label: "Geneva, CH",
    code: "GVA",
    description: "Geneva Cointrin International Airport",
    type: "AIRPORT",
  },
  {
    id: "gyd",
    label: "Baku, AZ",
    code: "GYD",
    description: "Heydar Aliyev International Airport",
    type: "AIRPORT",
  },
  {
    id: "gye",
    label: "Guayaquil, EC",
    code: "GYE",
    description: "Simon Bolivar International Airport",
    type: "AIRPORT",
  },
  {
    id: "gzp",
    label: "Gazipasa, TR",
    code: "GZP",
    description: "Gazipasa Airport",
    type: "AIRPORT",
  },
  {
    id: "haj",
    label: "Hannover, DE",
    code: "HAJ",
    description: "Hannover Airport",
    type: "AIRPORT",
  },
  {
    id: "hak",
    label: "Haikou, CN",
    code: "HAK",
    description: "Haikou Meilan International Airport",
    type: "AIRPORT",
  },
  {
    id: "ham",
    label: "Hamburg, DE",
    code: "HAM",
    description: "Hamburg Airport",
    type: "AIRPORT",
  },
  {
    id: "han",
    label: "Hanoi, VN",
    code: "HAN",
    description: "Noi Bai International Airport",
    type: "AIRPORT",
  },
  {
    id: "has",
    label: "Hail, SA",
    code: "HAS",
    description: "Hail Airport",
    type: "AIRPORT",
  },
  {
    id: "hav",
    label: "Havana, CU",
    code: "HAV",
    description: "Jose Marti International Airport",
    type: "AIRPORT",
  },
  {
    id: "hba",
    label: "Hobart, AU",
    code: "HBA",
    description: "Hobart International Airport",
    type: "AIRPORT",
  },
  {
    id: "hbe",
    label: "Alexandria, EG",
    code: "HBE",
    description: "Borg El Arab International Airport",
    type: "AIRPORT",
  },
  {
    id: "hdn",
    label: "Hayden, US",
    code: "HDN",
    description: "Yampa Valley Airport",
    type: "AIRPORT",
  },
  {
    id: "hel",
    label: "Helsinki, FI",
    code: "HEL",
    description: "Helsinki Vantaa Airport",
    type: "AIRPORT",
  },
  {
    id: "her",
    label: "Heraklion, GR",
    code: "HER",
    description: "Heraklion International Nikos Kazantzakis Airport",
    type: "AIRPORT",
  },
  {
    id: "hgh",
    label: "Hangzhou, CN",
    code: "HGH",
    description: "Hangzhou Xiaoshan International Airport",
    type: "AIRPORT",
  },
  {
    id: "hhh",
    label: "Hilton Head Island, US",
    code: "HHH",
    description: "Hilton Head Airport",
    type: "AIRPORT",
  },
  {
    id: "hid",
    label: "Horn Island, AU",
    code: "HID",
    description: "Horn Island Airport",
    type: "AIRPORT",
  },
  {
    id: "hij",
    label: "Hiroshima, JP",
    code: "HIJ",
    description: "Hiroshima Airport",
    type: "AIRPORT",
  },
  {
    id: "hir",
    label: "Honiara, SB",
    code: "HIR",
    description: "Honiara International Airport",
    type: "AIRPORT",
  },
  {
    id: "hkd",
    label: "Hakodate, JP",
    code: "HKD",
    description: "Hakodate Airport",
    type: "AIRPORT",
  },
  {
    id: "hkg",
    label: "Hong Kong, HK",
    code: "HKG",
    description: "Chek Lap Kok International Airport",
    type: "AIRPORT",
  },
  {
    id: "hkt",
    label: "Phuket, TH",
    code: "HKT",
    description: "Phuket International Airport",
    type: "AIRPORT",
  },
  {
    id: "hln",
    label: "Helena, US",
    code: "HLN",
    description: "Helena Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "hmo",
    label: "Hermosillo, MX",
    code: "HMO",
    description: "General Ignacio P. Garcia International Airport",
    type: "AIRPORT",
  },
  {
    id: "hna",
    label: "Hanamaki, JP",
    code: "HNA",
    description: "Hanamaki Airport",
    type: "AIRPORT",
  },
  {
    id: "hnd",
    label: "Tokyo, JP",
    code: "HND",
    description: "Tokyo International Airport",
    type: "AIRPORT",
    parentMetroCode: "TYO",
  },
  {
    id: "hnl",
    label: "Honolulu, US",
    code: "HNL",
    description: "Daniel K Inouye International Airport",
    type: "AIRPORT",
  },
  {
    id: "hog",
    label: "Holguin, CU",
    code: "HOG",
    description: "Frank Pais International Airport",
    type: "AIRPORT",
  },
  {
    id: "hou",
    label: "Houston-Hobby, US",
    code: "HOU",
    description: "William P. Hobby Airport",
    type: "AIRPORT",
  },
  {
    id: "hpn",
    label: "White Plains, US",
    code: "HPN",
    description: "Westchester County Airport",
    type: "AIRPORT",
  },
  {
    id: "hre",
    label: "Harare, ZW",
    code: "HRE",
    description: "Harare International Airport",
    type: "AIRPORT",
  },
  {
    id: "hrg",
    label: "Hurghada, EG",
    code: "HRG",
    description: "Hurghada International Airport",
    type: "AIRPORT",
  },
  {
    id: "hrl",
    label: "Harlingen, US",
    code: "HRL",
    description: "Valley International Airport",
    type: "AIRPORT",
  },
  {
    id: "hsv",
    label: "Huntsville, US",
    code: "HSV",
    description: "Huntsville International-Carl T Jones Field",
    type: "AIRPORT",
  },
  {
    id: "hti",
    label: "Hamilton Island, AU",
    code: "HTI",
    description: "Hamilton Island Airport",
    type: "AIRPORT",
  },
  {
    id: "hts",
    label: "Huntington, US",
    code: "HTS",
    description: "Tri-State Airport",
    type: "AIRPORT",
  },
  {
    id: "hux",
    label: "Huatulco, MX",
    code: "HUX",
    description: "Bahias de Huatulco International Airport",
    type: "AIRPORT",
  },
  {
    id: "hvb",
    label: "Hervey Bay, AU",
    code: "HVB",
    description: "Hervey Bay Airport",
    type: "AIRPORT",
  },
  {
    id: "hya",
    label: "Hyannis, US",
    code: "HYA",
    description: "Cape Cod Gateway Airport",
    type: "AIRPORT",
  },
  {
    id: "hyd",
    label: "Hyderabad, IN",
    code: "HYD",
    description: "Rajiv Gandhi International Airport Shamshabad",
    type: "AIRPORT",
  },
  {
    id: "iad",
    label: "Washington, US",
    code: "IAD",
    description: "Washington Dulles International Airport",
    type: "AIRPORT",
    parentMetroCode: "WAS",
  },
  {
    id: "iah",
    label: "Houston, US",
    code: "IAH",
    description: "George Bush Intcntl/Houston Airport",
    type: "AIRPORT",
  },
  {
    id: "ibz",
    label: "Ibiza, ES",
    code: "IBZ",
    description: "Ibiza Airport",
    type: "AIRPORT",
  },
  {
    id: "ici",
    label: "Cicia, FJ",
    code: "ICI",
    description: "Cicia Airport",
    type: "AIRPORT",
  },
  {
    id: "icn",
    label: "Seoul, KR",
    code: "ICN",
    description: "Incheon International Airport",
    type: "AIRPORT",
    parentMetroCode: "SEL",
  },
  {
    id: "ict",
    label: "Wichita, US",
    code: "ICT",
    description: "Wichita Dwight D Eisenhower Ntl Airport",
    type: "AIRPORT",
  },
  {
    id: "ida",
    label: "Idaho Falls, US",
    code: "IDA",
    description: "Idaho Falls Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "ika",
    label: "Tehran, IR",
    code: "IKA",
    description: "Imam Khomeini International Airport",
    type: "AIRPORT",
  },
  {
    id: "ild",
    label: "Lleida-Alguaire, ES",
    code: "ILD",
    description: "Lleida–Alguaire Airport",
    type: "AIRPORT",
  },
  {
    id: "ilm",
    label: "Wilmington, US",
    code: "ILM",
    description: "Wilmington International Airport",
    type: "AIRPORT",
  },
  {
    id: "ind",
    label: "Indianapolis, US",
    code: "IND",
    description: "Indianapolis International Airport",
    type: "AIRPORT",
  },
  {
    id: "inn",
    label: "Innsbruck, AT",
    code: "INN",
    description: "Innsbruck Airport",
    type: "AIRPORT",
  },
  {
    id: "inv",
    label: "Inverness, GB",
    code: "INV",
    description: "Inverness Airport",
    type: "AIRPORT",
  },
  {
    id: "isa",
    label: "Mount Isa, AU",
    code: "ISA",
    description: "Mount Isa Airport",
    type: "AIRPORT",
  },
  {
    id: "isb",
    label: "Islamabad, PK",
    code: "ISB",
    description: "Islamabad International Airport",
    type: "AIRPORT",
  },
  {
    id: "isg",
    label: "Ishigaki, JP",
    code: "ISG",
    description: "Ishigaki Airport",
    type: "AIRPORT",
  },
  {
    id: "ist",
    label: "Istanbul, TR",
    code: "IST",
    description: "Istanbul Airport",
    type: "AIRPORT",
  },
  {
    id: "isu",
    label: "Sulaymaniyah, IQ",
    code: "ISU",
    description: "Sulaymaniyah International Airport",
    type: "AIRPORT",
  },
  {
    id: "itm",
    label: "Osaka, JP",
    code: "ITM",
    description: "Osaka International Airport",
    type: "AIRPORT",
    parentMetroCode: "OSA",
  },
  {
    id: "ito",
    label: "Hilo, US",
    code: "ITO",
    description: "Hilo International Airport",
    type: "AIRPORT",
  },
  {
    id: "ivl",
    label: "Ivalo, FI",
    code: "IVL",
    description: "Ivalo Airport",
    type: "AIRPORT",
  },
  {
    id: "ixm",
    label: "Madurai, IN",
    code: "IXM",
    description: "Madurai Airport",
    type: "AIRPORT",
  },
  {
    id: "izo",
    label: "Izumo, JP",
    code: "IZO",
    description: "Izumo Airport",
    type: "AIRPORT",
  },
  {
    id: "jac",
    label: "Jackson, US",
    code: "JAC",
    description: "Jackson Hole Airport",
    type: "AIRPORT",
  },
  {
    id: "jan",
    label: "Jackson, US",
    code: "JAN",
    description: "Jackson–Medgar Wiley Evers International Airport",
    type: "AIRPORT",
  },
  {
    id: "jax",
    label: "Jacksonville, US",
    code: "JAX",
    description: "Jacksonville International Airport",
    type: "AIRPORT",
  },
  {
    id: "jed",
    label: "Jeddah, SA",
    code: "JED",
    description: "King Abdulaziz International Airport",
    type: "AIRPORT",
  },
  {
    id: "jer",
    label: "Saint Helier, GB",
    code: "JER",
    description: "Jersey Airport",
    type: "AIRPORT",
  },
  {
    id: "jfk",
    label: "New York, US",
    code: "JFK",
    description: "John F Kennedy International Airport",
    type: "AIRPORT",
    parentMetroCode: "NYC",
  },
  {
    id: "jhb",
    label: "Senai, MY",
    code: "JHB",
    description: "Senai International Airport",
    type: "AIRPORT",
  },
  {
    id: "jib",
    label: "Djibouti City, DJ",
    code: "JIB",
    description: "Djibouti-Ambouli Airport",
    type: "AIRPORT",
  },
  {
    id: "jmk",
    label: "Mykonos Island, GR",
    code: "JMK",
    description: "Mikonos Airport",
    type: "AIRPORT",
  },
  {
    id: "jnb",
    label: "Johannesburg, ZA",
    code: "JNB",
    description: "O. R. Tambo International Airport",
    type: "AIRPORT",
  },
  {
    id: "jnu",
    label: "Juneau, US",
    code: "JNU",
    description: "Juneau International Airport",
    type: "AIRPORT",
  },
  {
    id: "joe",
    label: "Joensuu, FI",
    code: "JOE",
    description: "Joensuu Airport",
    type: "AIRPORT",
  },
  {
    id: "jro",
    label: "Arusha, TZ",
    code: "JRO",
    description: "Kilimanjaro International Airport",
    type: "AIRPORT",
  },
  {
    id: "jsi",
    label: "Skiathos, GR",
    code: "JSI",
    description: "Skiathos Alexandros Papadiamantis Airport",
    type: "AIRPORT",
  },
  {
    id: "jtr",
    label: "Santorini Island, GR",
    code: "JTR",
    description: "Santorini Airport",
    type: "AIRPORT",
  },
  {
    id: "jyv",
    label: "Jyvaskyla, FI",
    code: "JYV",
    description: "Jyväskylä Airport",
    type: "AIRPORT",
  },
  {
    id: "kaj",
    label: "Kajaani, FI",
    code: "KAJ",
    description: "Kajaani Airport",
    type: "AIRPORT",
  },
  {
    id: "kan",
    label: "Kano, NG",
    code: "KAN",
    description: "Mallam Aminu International Airport",
    type: "AIRPORT",
  },
  {
    id: "kao",
    label: "Kuusamo, FI",
    code: "KAO",
    description: "Kuusamo Airport",
    type: "AIRPORT",
  },
  {
    id: "kbr",
    label: "Kota Baharu, MY",
    code: "KBR",
    description: "Sultan Ismail Petra Airport",
    type: "AIRPORT",
  },
  {
    id: "kbv",
    label: "Krabi, TH",
    code: "KBV",
    description: "Krabi Airport",
    type: "AIRPORT",
  },
  {
    id: "kch",
    label: "Kuching, MY",
    code: "KCH",
    description: "Kuching International Airport",
    type: "AIRPORT",
  },
  {
    id: "kcz",
    label: "Nankoku, JP",
    code: "KCZ",
    description: "Kochi Ryoma Airport",
    type: "AIRPORT",
  },
  {
    id: "kdv",
    label: "Vunisea, FJ",
    code: "KDV",
    description: "Vunisea Airport",
    type: "AIRPORT",
  },
  {
    id: "kef",
    label: "Reykjavik, IS",
    code: "KEF",
    description: "Keflavik International Airport",
    type: "AIRPORT",
  },
  {
    id: "kem",
    label: "Kemi/Tornio, FI",
    code: "KEM",
    description: "Kemi-Tornio Airport",
    type: "AIRPORT",
  },
  {
    id: "kgc",
    label: "Kingscote, AU",
    code: "KGC",
    description: "Kingscote Airport",
    type: "AIRPORT",
  },
  {
    id: "kgi",
    label: "Kalgoorlie, AU",
    code: "KGI",
    description: "Kalgoorlie-Boulder Airport",
    type: "AIRPORT",
  },
  {
    id: "kgl",
    label: "Kigali, RW",
    code: "KGL",
    description: "Kigali International Airport",
    type: "AIRPORT",
  },
  {
    id: "kgs",
    label: "Kos Island, GR",
    code: "KGS",
    description: "Kos Airport",
    type: "AIRPORT",
  },
  {
    id: "khh",
    label: "Kaohsiung City, TW",
    code: "KHH",
    description: "Kaohsiung International Airport",
    type: "AIRPORT",
  },
  {
    id: "khi",
    label: "Karachi, PK",
    code: "KHI",
    description: "Jinnah International Airport",
    type: "AIRPORT",
  },
  {
    id: "khs",
    label: "Khasab, OM",
    code: "KHS",
    description: "Khasab Air Base",
    type: "AIRPORT",
  },
  {
    id: "kij",
    label: "Niigata, JP",
    code: "KIJ",
    description: "Niigata Airport",
    type: "AIRPORT",
  },
  {
    id: "kin",
    label: "Kingston, JM",
    code: "KIN",
    description: "Norman Manley International Airport",
    type: "AIRPORT",
  },
  {
    id: "kix",
    label: "Osaka, JP",
    code: "KIX",
    description: "Kansai International Airport",
    type: "AIRPORT",
    parentMetroCode: "OSA",
  },
  {
    id: "kkj",
    label: "Kitakyushu, JP",
    code: "KKJ",
    description: "Kitakyushu Airport",
    type: "AIRPORT",
  },
  {
    id: "kkn",
    label: "Kirkenes, NO",
    code: "KKN",
    description: "Kirkenes Airport, Høybuktmoen",
    type: "AIRPORT",
  },
  {
    id: "kkx",
    label: "Kikai, JP",
    code: "KKX",
    description: "Kikai Airport",
    type: "AIRPORT",
  },
  {
    id: "klx",
    label: "Kalamata, GR",
    code: "KLX",
    description: "Kalamata International Airport",
    type: "AIRPORT",
  },
  {
    id: "kmi",
    label: "Miyazaki, JP",
    code: "KMI",
    description: "Miyazaki Airport",
    type: "AIRPORT",
  },
  {
    id: "kmj",
    label: "Kumamoto, JP",
    code: "KMJ",
    description: "Kumamoto Airport",
    type: "AIRPORT",
  },
  {
    id: "kmq",
    label: "Kanazawa, JP",
    code: "KMQ",
    description: "Komatsu Airport",
    type: "AIRPORT",
  },
  {
    id: "kno",
    label: "Medan, Sumatra Island, ID",
    code: "KNO",
    description: "Polonia International Airport",
    type: "AIRPORT",
  },
  {
    id: "koa",
    label: "Kailua-Kona, US",
    code: "KOA",
    description: "Ellison Onizuka Kona International At Keahole Airport",
    type: "AIRPORT",
  },
  {
    id: "koj",
    label: "Kagoshima, JP",
    code: "KOJ",
    description: "Kagoshima Airport",
    type: "AIRPORT",
  },
  {
    id: "kok",
    label: "Kokkola, FI",
    code: "KOK",
    description: "Kokkola-Pietarsaari Airport",
    type: "AIRPORT",
  },
  {
    id: "krk",
    label: "Kraków, PL",
    code: "KRK",
    description: "John Paul II International Airport Kraków-Balice Airport",
    type: "AIRPORT",
  },
  {
    id: "kta",
    label: "Karratha, AU",
    code: "KTA",
    description: "Karratha Airport",
    type: "AIRPORT",
  },
  {
    id: "ktd",
    label: "Kita-Daito, JP",
    code: "KTD",
    description: "Kitadaito Airport",
    type: "AIRPORT",
  },
  {
    id: "kti",
    label: "Krong Ta Khmau, KH",
    code: "KTI",
    description: "Techo International Airport",
    type: "AIRPORT",
  },
  {
    id: "ktm",
    label: "Kathmandu, NP",
    code: "KTM",
    description: "Tribhuvan International Airport",
    type: "AIRPORT",
  },
  {
    id: "ktn",
    label: "Ketchikan, US",
    code: "KTN",
    description: "Ketchikan International Airport",
    type: "AIRPORT",
  },
  {
    id: "ktt",
    label: "Kittila, FI",
    code: "KTT",
    description: "Kittila Airport",
    type: "AIRPORT",
  },
  {
    id: "kua",
    label: "Kuantan, MY",
    code: "KUA",
    description: "Kuantan Airport",
    type: "AIRPORT",
  },
  {
    id: "kuh",
    label: "Kushiro, JP",
    code: "KUH",
    description: "Kushiro Airport",
    type: "AIRPORT",
  },
  {
    id: "kul",
    label: "Kuala Lumpur, MY",
    code: "KUL",
    description: "Kuala Lumpur International Airport",
    type: "AIRPORT",
  },
  {
    id: "kum",
    label: "Yaku Shima, JP",
    code: "KUM",
    description: "Yakushima Airport",
    type: "AIRPORT",
  },
  {
    id: "kuo",
    label: "Kuopio, FI",
    code: "KUO",
    description: "Kuopio Airport",
    type: "AIRPORT",
  },
  {
    id: "kwi",
    label: "Kuwait City, KW",
    code: "KWI",
    description: "Kuwait International Airport",
    type: "AIRPORT",
  },
  {
    id: "kxf",
    label: "Koro Island, FJ",
    code: "KXF",
    description: "Koro Island Airport",
    type: "AIRPORT",
  },
  {
    id: "lad",
    label: "Luanda, AO",
    code: "LAD",
    description: "Quatro De Fevereiro Airport",
    type: "AIRPORT",
  },
  {
    id: "lan",
    label: "Lansing, US",
    code: "LAN",
    description: "Capital Region International Airport",
    type: "AIRPORT",
  },
  {
    id: "lap",
    label: "La Paz, MX",
    code: "LAP",
    description: "Manuel Márquez de León International Airport",
    type: "AIRPORT",
  },
  {
    id: "las",
    label: "Las Vegas, US",
    code: "LAS",
    description: "Harry Reid International Airport",
    type: "AIRPORT",
  },
  {
    id: "law",
    label: "Lawton/Fort Sill, US",
    code: "LAW",
    description: "Lawton–Fort Sill Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "lax",
    label: "Los Angeles, US",
    code: "LAX",
    description: "Los Angeles International Airport",
    type: "AIRPORT",
  },
  {
    id: "lbb",
    label: "Lubbock, US",
    code: "LBB",
    description: "Lubbock Preston Smith International Airport",
    type: "AIRPORT",
  },
  {
    id: "lbs",
    label: "Labasa, FJ",
    code: "LBS",
    description: "Labasa Airport",
    type: "AIRPORT",
  },
  {
    id: "lbu",
    label: "Labuan, MY",
    code: "LBU",
    description: "Labuan Airport",
    type: "AIRPORT",
  },
  {
    id: "lbv",
    label: "Libreville, GA",
    code: "LBV",
    description: "Leon M Ba Airport",
    type: "AIRPORT",
  },
  {
    id: "lca",
    label: "Larnarca, CY",
    code: "LCA",
    description: "Larnaca International Airport",
    type: "AIRPORT",
  },
  {
    id: "lcg",
    label: "Culleredo, ES",
    code: "LCG",
    description: "A Coruna Airport",
    type: "AIRPORT",
  },
  {
    id: "lch",
    label: "Lake Charles, US",
    code: "LCH",
    description: "Lake Charles Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "lcy",
    label: "London, GB",
    code: "LCY",
    description: "London City Airport",
    type: "AIRPORT",
    parentMetroCode: "LON",
  },
  {
    id: "lde",
    label: "Tarbes/Lourdes/Pyrenees, FR",
    code: "LDE",
    description: "Tarbes-Lourdes-Pyrenees Airport",
    type: "AIRPORT",
  },
  {
    id: "ldu",
    label: "Lahad Datu, MY",
    code: "LDU",
    description: "Lahad Datu Airport",
    type: "AIRPORT",
  },
  {
    id: "lea",
    label: "Learmonth, AU",
    code: "LEA",
    description: "Learmonth Airport",
    type: "AIRPORT",
  },
  {
    id: "led",
    label: "St. Petersburg, RU",
    code: "LED",
    description: "Pulkovo Airport",
    type: "AIRPORT",
  },
  {
    id: "lei",
    label: "Almeria, ES",
    code: "LEI",
    description: "Almería Airport",
    type: "AIRPORT",
  },
  {
    id: "lej",
    label: "Leipzig, DE",
    code: "LEJ",
    description: "Leipzig/Halle Airport",
    type: "AIRPORT",
  },
  {
    id: "len",
    label: "Leon, ES",
    code: "LEN",
    description: "León Airport",
    type: "AIRPORT",
  },
  {
    id: "leu",
    label: "Seo de Urgel, ES",
    code: "LEU",
    description: "Andorra–La Seu d'Urgell Airport",
    type: "AIRPORT",
  },
  {
    id: "lex",
    label: "Lexington, US",
    code: "LEX",
    description: "Blue Grass Airport",
    type: "AIRPORT",
  },
  {
    id: "lft",
    label: "Lafayette, US",
    code: "LFT",
    description: "Lafayette Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "lfw",
    label: "Lome, TG",
    code: "LFW",
    description: "Lome-Tokoin Airport",
    type: "AIRPORT",
  },
  {
    id: "lga",
    label: "New York, US",
    code: "LGA",
    description: "Laguardia Airport",
    type: "AIRPORT",
    parentMetroCode: "NYC",
  },
  {
    id: "lgb",
    label: "Long Beach, US",
    code: "LGB",
    description: "Long Beach (Daugherty Field) Airport",
    type: "AIRPORT",
  },
  {
    id: "lgk",
    label: "Langkawi, MY",
    code: "LGK",
    description: "Langkawi International Airport",
    type: "AIRPORT",
  },
  {
    id: "lgw",
    label: "London, GB",
    code: "LGW",
    description: "London Gatwick Airport",
    type: "AIRPORT",
    parentMetroCode: "LON",
  },
  {
    id: "lhe",
    label: "Lahore, PK",
    code: "LHE",
    description: "Alama Iqbal International Airport",
    type: "AIRPORT",
  },
  {
    id: "lhg",
    label: "Lightning Ridge, AU",
    code: "LHG",
    description: "Lightning Ridge Airport",
    type: "AIRPORT",
  },
  {
    id: "lhr",
    label: "London, GB",
    code: "LHR",
    description: "London Heathrow Airport",
    type: "AIRPORT",
    parentMetroCode: "LON",
  },
  {
    id: "lih",
    label: "Lihue, US",
    code: "LIH",
    description: "Lihue Airport",
    type: "AIRPORT",
  },
  {
    id: "lil",
    label: "Lille/Lesquin, FR",
    code: "LIL",
    description: "Lille-Lesquin Airport",
    type: "AIRPORT",
  },
  {
    id: "lim",
    label: "Lima, PE",
    code: "LIM",
    description: "Jorge Chavez International Airport",
    type: "AIRPORT",
  },
  {
    id: "lin",
    label: "Milan, IT",
    code: "LIN",
    description: "Linate Airport",
    type: "AIRPORT",
  },
  {
    id: "lir",
    label: "Liberia, CR",
    code: "LIR",
    description: "Daniel Oduber Quiros International Airport",
    type: "AIRPORT",
  },
  {
    id: "lis",
    label: "Lisbon, PT",
    code: "LIS",
    description: "Lisbon Portela Airport",
    type: "AIRPORT",
  },
  {
    id: "lit",
    label: "Little Rock, US",
    code: "LIT",
    description: "Bill And Hillary Clinton Ntl/Adams Field",
    type: "AIRPORT",
  },
  {
    id: "lju",
    label: "Ljubljana, SI",
    code: "LJU",
    description: "Ljubljana Joze Pucnik Airport",
    type: "AIRPORT",
  },
  {
    id: "lkb",
    label: "Lakeba Island, FJ",
    code: "LKB",
    description: "Lakeba Island Airport",
    type: "AIRPORT",
  },
  {
    id: "lko",
    label: "Lucknow, IN",
    code: "LKO",
    description: "Chaudhary Charan Singh International Airport",
    type: "AIRPORT",
  },
  {
    id: "lmn",
    label: "Limbang, MY",
    code: "LMN",
    description: "Limbang Airport",
    type: "AIRPORT",
  },
  {
    id: "lnk",
    label: "Lincoln, US",
    code: "LNK",
    description: "Lincoln Airport",
    type: "AIRPORT",
  },
  {
    id: "los",
    label: "Lagos, NG",
    code: "LOS",
    description: "Murtala Muhammed International Airport",
    type: "AIRPORT",
  },
  {
    id: "lpa",
    label: "Gran Canaria Island, ES",
    code: "LPA",
    description: "Gran Canaria Airport",
    type: "AIRPORT",
  },
  {
    id: "lrd",
    label: "Laredo, US",
    code: "LRD",
    description: "Laredo International Airport",
    type: "AIRPORT",
  },
  {
    id: "lre",
    label: "Longreach, AU",
    code: "LRE",
    description: "Longreach Airport",
    type: "AIRPORT",
  },
  {
    id: "lrm",
    label: "La Romana, DO",
    code: "LRM",
    description: "Casa De Campo International Airport",
    type: "AIRPORT",
  },
  {
    id: "lse",
    label: "La Crosse, US",
    code: "LSE",
    description: "La Crosse Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "lst",
    label: "Launceston, AU",
    code: "LST",
    description: "Launceston Airport",
    type: "AIRPORT",
  },
  {
    id: "lto",
    label: "Loreto, MX",
    code: "LTO",
    description: "Loreto International Airport",
    type: "AIRPORT",
  },
  {
    id: "lun",
    label: "Lusaka, ZM",
    code: "LUN",
    description: "Kenneth Kaunda International Airport",
    type: "AIRPORT",
  },
  {
    id: "lux",
    label: "Luxembourg, LU",
    code: "LUX",
    description: "Luxembourg-Findel International Airport",
    type: "AIRPORT",
  },
  {
    id: "lwb",
    label: "Lewisburg, US",
    code: "LWB",
    description: "Greenbrier Valley Airport",
    type: "AIRPORT",
  },
  {
    id: "lyh",
    label: "Lynchburg, US",
    code: "LYH",
    description: "Lynchburg Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "lys",
    label: "Lyon, FR",
    code: "LYS",
    description: "Lyon Saint-Exupery Airport",
    type: "AIRPORT",
  },
  {
    id: "maa",
    label: "Chennai, IN",
    code: "MAA",
    description: "Chennai International Airport",
    type: "AIRPORT",
  },
  {
    id: "mad",
    label: "Madrid, ES",
    code: "MAD",
    description: "Madrid Barajas International Airport",
    type: "AIRPORT",
  },
  {
    id: "maf",
    label: "Midland/Odessa, US",
    code: "MAF",
    description: "Midland International Air and Space Port",
    type: "AIRPORT",
  },
  {
    id: "mah",
    label: "Menorca, ES",
    code: "MAH",
    description: "Menorca Airport",
    type: "AIRPORT",
  },
  {
    id: "man",
    label: "Manchester, GB",
    code: "MAN",
    description: "Manchester Airport",
    type: "AIRPORT",
  },
  {
    id: "mar",
    label: "Maracaibo, VE",
    code: "MAR",
    description: "La Chinita International Airport",
    type: "AIRPORT",
  },
  {
    id: "mbj",
    label: "Montego Bay, JM",
    code: "MBJ",
    description: "Sangster International Airport",
    type: "AIRPORT",
  },
  {
    id: "mci",
    label: "Kansas City, US",
    code: "MCI",
    description: "Kansas City International Airport",
    type: "AIRPORT",
  },
  {
    id: "mco",
    label: "Orlando, US",
    code: "MCO",
    description: "Orlando International Airport",
    type: "AIRPORT",
  },
  {
    id: "mct",
    label: "Muscat, OM",
    code: "MCT",
    description: "Muscat International Airport",
    type: "AIRPORT",
  },
  {
    id: "mcy",
    label: "Maroochydore, AU",
    code: "MCY",
    description: "Sunshine Coast Airport",
    type: "AIRPORT",
  },
  {
    id: "mde",
    label: "Rionegro, CO",
    code: "MDE",
    description: "Jose Maria Cordova International Airport",
    type: "AIRPORT",
  },
  {
    id: "mdt",
    label: "Harrisburg, US",
    code: "MDT",
    description: "Harrisburg International Airport",
    type: "AIRPORT",
  },
  {
    id: "med",
    label: "Medina, SA",
    code: "MED",
    description: "Prince Mohammad Bin Abdulaziz Airport",
    type: "AIRPORT",
  },
  {
    id: "mel",
    label: "Melbourne, AU",
    code: "MEL",
    description: "Melbourne International Airport",
    type: "AIRPORT",
  },
  {
    id: "mem",
    label: "Memphis, US",
    code: "MEM",
    description: "Frederick W Smith International Airport",
    type: "AIRPORT",
  },
  {
    id: "mex",
    label: "Mexico City, MX",
    code: "MEX",
    description: "Licenciado Benito Juarez International Airport",
    type: "AIRPORT",
  },
  {
    id: "mfe",
    label: "Mc Allen, US",
    code: "MFE",
    description: "Mc Allen International Airport",
    type: "AIRPORT",
  },
  {
    id: "mfr",
    label: "Medford, US",
    code: "MFR",
    description: "Rogue Valley International–Medford Airport",
    type: "AIRPORT",
  },
  {
    id: "mga",
    label: "Managua, NI",
    code: "MGA",
    description: "Augusto C. Sandino (Managua) International Airport",
    type: "AIRPORT",
  },
  {
    id: "mgb",
    label: "Mt. Gambier, AU",
    code: "MGB",
    description: "Mount Gambier Airport",
    type: "AIRPORT",
  },
  {
    id: "mgm",
    label: "Montgomery, US",
    code: "MGM",
    description: "Montgomery Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "mgq",
    label: "Mogadishu, SO",
    code: "MGQ",
    description: "Aden Adde International Airport",
    type: "AIRPORT",
  },
  {
    id: "mhd",
    label: "Mashhad, IR",
    code: "MHD",
    description: "Mashhad International Airport",
    type: "AIRPORT",
  },
  {
    id: "mhh",
    label: "Marsh Harbour, BS",
    code: "MHH",
    description: "Leonard M. Thompson International Airport",
    type: "AIRPORT",
  },
  {
    id: "mhk",
    label: "Manhattan, US",
    code: "MHK",
    description: "Manhattan Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "mhq",
    label: "Mariehamn, FI",
    code: "MHQ",
    description: "Mariehamn Airport",
    type: "AIRPORT",
  },
  {
    id: "mht",
    label: "Manchester, US",
    code: "MHT",
    description: "Manchester–Boston Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "mia",
    label: "Miami, US",
    code: "MIA",
    description: "Miami International Airport",
    type: "AIRPORT",
  },
  {
    id: "mid",
    label: "Merida, MX",
    code: "MID",
    description: "Licenciado Manuel Crescencio Rejon Int Airport",
    type: "AIRPORT",
  },
  {
    id: "mim",
    label: "Merimbula, AU",
    code: "MIM",
    description: "Merimbula Airport",
    type: "AIRPORT",
  },
  {
    id: "mji",
    label: "Tripoli, LY",
    code: "MJI",
    description: "Mitiga Airport",
    type: "AIRPORT",
  },
  {
    id: "mke",
    label: "Milwaukee, US",
    code: "MKE",
    description: "General Mitchell International Airport",
    type: "AIRPORT",
  },
  {
    id: "mkm",
    label: "Mukah, MY",
    code: "MKM",
    description: "Mukah Airport",
    type: "AIRPORT",
  },
  {
    id: "mky",
    label: "Mackay, AU",
    code: "MKY",
    description: "Mackay Airport",
    type: "AIRPORT",
  },
  {
    id: "mla",
    label: "Luqa, MT",
    code: "MLA",
    description: "Luqa Airport",
    type: "AIRPORT",
  },
  {
    id: "mlb",
    label: "Melbourne, US",
    code: "MLB",
    description: "Melbourne Orlando International Airport",
    type: "AIRPORT",
  },
  {
    id: "mle",
    label: "Malé, MV",
    code: "MLE",
    description: "Velana International Airport",
    type: "AIRPORT",
  },
  {
    id: "mli",
    label: "Moline, US",
    code: "MLI",
    description: "Quad Cities International Airport",
    type: "AIRPORT",
  },
  {
    id: "mlm",
    label: "Morelia, MX",
    code: "MLM",
    description: "General Francisco J. Mujica International Airport",
    type: "AIRPORT",
  },
  {
    id: "mln",
    label: "Melilla, ES",
    code: "MLN",
    description: "Melilla Airport",
    type: "AIRPORT",
  },
  {
    id: "mlu",
    label: "Monroe, US",
    code: "MLU",
    description: "Monroe Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "mmb",
    label: "Ozora, JP",
    code: "MMB",
    description: "Memanbetsu Airport",
    type: "AIRPORT",
  },
  {
    id: "mmd",
    label: "Minamidaito, JP",
    code: "MMD",
    description: "Minami-Daito Airport",
    type: "AIRPORT",
  },
  {
    id: "mmj",
    label: "Matsumoto, JP",
    code: "MMJ",
    description: "Matsumoto Airport",
    type: "AIRPORT",
  },
  {
    id: "mmy",
    label: "Miyako City, JP",
    code: "MMY",
    description: "Miyako Airport",
    type: "AIRPORT",
  },
  {
    id: "mnl",
    label: "Manila, PH",
    code: "MNL",
    description: "Ninoy Aquino International Airport",
    type: "AIRPORT",
  },
  {
    id: "mob",
    label: "Mobile, US",
    code: "MOB",
    description: "Mobile Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "mov",
    label: "Moranbah, AU",
    code: "MOV",
    description: "Moranbah Airport",
    type: "AIRPORT",
  },
  {
    id: "mpl",
    label: "Montpellier/Mediterranee, FR",
    code: "MPL",
    description: "Montpellier-Mediterranee Airport",
    type: "AIRPORT",
  },
  {
    id: "mpm",
    label: "Maputo, MZ",
    code: "MPM",
    description: "Maputo Airport",
    type: "AIRPORT",
  },
  {
    id: "mql",
    label: "Mildura, AU",
    code: "MQL",
    description: "Mildura Airport",
    type: "AIRPORT",
  },
  {
    id: "mqt",
    label: "Marquette, US",
    code: "MQT",
    description: "Sawyer International Airport",
    type: "AIRPORT",
  },
  {
    id: "mra",
    label: "Misrata, LY",
    code: "MRA",
    description: "Misrata International Airport",
    type: "AIRPORT",
  },
  {
    id: "mrs",
    label: "Marseille, FR",
    code: "MRS",
    description: "Marseille Provence Airport",
    type: "AIRPORT",
  },
  {
    id: "mru",
    label: "Port Louis, MU",
    code: "MRU",
    description: "Sir Seewoosagur Ramgoolam International Airport",
    type: "AIRPORT",
  },
  {
    id: "mry",
    label: "Monterey, US",
    code: "MRY",
    description: "Monterey Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "mrz",
    label: "Moree, AU",
    code: "MRZ",
    description: "Moree Airport",
    type: "AIRPORT",
  },
  {
    id: "msj",
    label: "Misawa, JP",
    code: "MSJ",
    description: "Misawa Air Base",
    type: "AIRPORT",
  },
  {
    id: "msn",
    label: "Madison, US",
    code: "MSN",
    description: "Dane County Regional/Truax Field",
    type: "AIRPORT",
  },
  {
    id: "mso",
    label: "Missoula, US",
    code: "MSO",
    description: "Missoula Montana Airport",
    type: "AIRPORT",
  },
  {
    id: "msp",
    label: "Minneapolis, US",
    code: "MSP",
    description: "Minneapolis-St Paul International/Wold-Chamberlain Airport",
    type: "AIRPORT",
  },
  {
    id: "msy",
    label: "New Orleans, US",
    code: "MSY",
    description: "Louis Armstrong New Orleans International Airport",
    type: "AIRPORT",
  },
  {
    id: "mtj",
    label: "Montrose, US",
    code: "MTJ",
    description: "Montrose Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "mty",
    label: "Monterrey, MX",
    code: "MTY",
    description: "General Mariano Escobedo International Airport",
    type: "AIRPORT",
  },
  {
    id: "muc",
    label: "Munich, DE",
    code: "MUC",
    description: "Munich International Airport",
    type: "AIRPORT",
  },
  {
    id: "mux",
    label: "Multan, PK",
    code: "MUX",
    description: "Multan International Airport",
    type: "AIRPORT",
  },
  {
    id: "mvd",
    label: "Montevideo, UY",
    code: "MVD",
    description: "Carrasco International /General C L Berisso Airport",
    type: "AIRPORT",
  },
  {
    id: "mvy",
    label: "Martha's Vineyard, US",
    code: "MVY",
    description: "Martha's Vineyard Airport",
    type: "AIRPORT",
  },
  {
    id: "mwa",
    label: "Marion, US",
    code: "MWA",
    description: "Veterans Airport of Southern Illinois",
    type: "AIRPORT",
  },
  {
    id: "mxp",
    label: "Milan, IT",
    code: "MXP",
    description: "Malpensa International Airport",
    type: "AIRPORT",
  },
  {
    id: "myj",
    label: "Matsuyama, JP",
    code: "MYJ",
    description: "Matsuyama Airport",
    type: "AIRPORT",
  },
  {
    id: "myr",
    label: "Myrtle Beach, US",
    code: "MYR",
    description: "Myrtle Beach International Airport",
    type: "AIRPORT",
  },
  {
    id: "myy",
    label: "Miri, MY",
    code: "MYY",
    description: "Miri Airport",
    type: "AIRPORT",
  },
  {
    id: "mzt",
    label: "Mazatlan, MX",
    code: "MZT",
    description: "General Rafael Buelna International Airport",
    type: "AIRPORT",
  },
  {
    id: "mzv",
    label: "Mulu, MY",
    code: "MZV",
    description: "Mulu Airport",
    type: "AIRPORT",
  },
  {
    id: "nag",
    label: "Naqpur, IN",
    code: "NAG",
    description: "Dr. Babasaheb Ambedkar International Airport",
    type: "AIRPORT",
  },
  {
    id: "nan",
    label: "Nadi, FJ",
    code: "NAN",
    description: "Nadi International Airport",
    type: "AIRPORT",
  },
  {
    id: "nap",
    label: "Napoli, IT",
    code: "NAP",
    description: "Napoli / Capodichino International Airport",
    type: "AIRPORT",
  },
  {
    id: "nas",
    label: "Nassau, BS",
    code: "NAS",
    description: "Lynden Pindling International Airport",
    type: "AIRPORT",
  },
  {
    id: "nbj",
    label: "Luanda, AO",
    code: "NBJ",
    description: "Dr. Antonio Agostinho Neto International Airport",
    type: "AIRPORT",
  },
  {
    id: "nbo",
    label: "Nairobi, KE",
    code: "NBO",
    description: "Jomo Kenyatta International Airport",
    type: "AIRPORT",
  },
  {
    id: "nce",
    label: "Nice, FR",
    code: "NCE",
    description: "Nice-Cote d'Azur Airport",
    type: "AIRPORT",
  },
  {
    id: "ncl",
    label: "Newcastle, GB",
    code: "NCL",
    description: "Newcastle Airport",
    type: "AIRPORT",
  },
  {
    id: "ndj",
    label: "N'Djamena, TD",
    code: "NDJ",
    description: "N'Djamena International Airport",
    type: "AIRPORT",
  },
  {
    id: "ndr",
    label: "Nador, MA",
    code: "NDR",
    description: "Nador International Airport",
    type: "AIRPORT",
  },
  {
    id: "ngb",
    label: "Ningbo, CN",
    code: "NGB",
    description: "Ningbo Lishe International Airport",
    type: "AIRPORT",
  },
  {
    id: "ngo",
    label: "Tokoname, JP",
    code: "NGO",
    description: "Chubu Centrair International Airport",
    type: "AIRPORT",
  },
  {
    id: "ngs",
    label: "Nagasaki, JP",
    code: "NGS",
    description: "Nagasaki Airport",
    type: "AIRPORT",
  },
  {
    id: "nim",
    label: "Niamey, NE",
    code: "NIM",
    description: "Diori Hamani International Airport",
    type: "AIRPORT",
  },
  {
    id: "njf",
    label: "Najaf, IQ",
    code: "NJF",
    description: "Al Najaf International Airport",
    type: "AIRPORT",
  },
  {
    id: "nkc",
    label: "Nouakchott, MR",
    code: "NKC",
    description: "Nouakchott International Airport",
    type: "AIRPORT",
  },
  {
    id: "nkg",
    label: "Nanjing, CN",
    code: "NKG",
    description: "Nanjing Lukou Airport",
    type: "AIRPORT",
  },
  {
    id: "nlk",
    label: "Burnt Pine, NF",
    code: "NLK",
    description: "Norfolk Island International Airport",
    type: "AIRPORT",
  },
  {
    id: "nou",
    label: "Noumea, NC",
    code: "NOU",
    description: "La Tontouta International Airport",
    type: "AIRPORT",
  },
  {
    id: "nrt",
    label: "Tokyo, JP",
    code: "NRT",
    description: "Narita International Airport",
    type: "AIRPORT",
    parentMetroCode: "TYO",
  },
  {
    id: "nsi",
    label: "Yaounde, CM",
    code: "NSI",
    description: "Yaounde Nsimalen International Airport",
    type: "AIRPORT",
  },
  {
    id: "nte",
    label: "Nantes, FR",
    code: "NTE",
    description: "Nantes Atlantique Airport",
    type: "AIRPORT",
  },
  {
    id: "ntl",
    label: "Newcastle, AU",
    code: "NTL",
    description: "Newcastle Airport",
    type: "AIRPORT",
  },
  {
    id: "nue",
    label: "Nuremberg, DE",
    code: "NUE",
    description: "Nuremberg Airport",
    type: "AIRPORT",
  },
  {
    id: "num",
    label: "Neom Bay, SA",
    code: "NUM",
    description: "Neom Bay Airport",
    type: "AIRPORT",
  },
  {
    id: "oag",
    label: "Orange, AU",
    code: "OAG",
    description: "Orange Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "oaj",
    label: "Jacksonville, US",
    code: "OAJ",
    description: "Albert J. Ellis Airport",
    type: "AIRPORT",
  },
  {
    id: "oak",
    label: "Oakland, US",
    code: "OAK",
    description: "Oakland San Francisco Bay Airport",
    type: "AIRPORT",
  },
  {
    id: "oax",
    label: "Oaxaca, MX",
    code: "OAX",
    description: "Xoxocotlan International Airport",
    type: "AIRPORT",
  },
  {
    id: "obo",
    label: "Obihiro, JP",
    code: "OBO",
    description: "Tokachi-Obihiro Airport",
    type: "AIRPORT",
  },
  {
    id: "ocj",
    label: "Ocho Rios, JM",
    code: "OCJ",
    description: "Ian Fleming International Airport",
    type: "AIRPORT",
  },
  {
    id: "ogg",
    label: "Kahului, US",
    code: "OGG",
    description: "Kahului Airport",
    type: "AIRPORT",
  },
  {
    id: "ogn",
    label: "Yonaguni, JP",
    code: "OGN",
    description: "Yonaguni Airport",
    type: "AIRPORT",
  },
  {
    id: "oir",
    label: "Okushiri, JP",
    code: "OIR",
    description: "Okushiri Airport",
    type: "AIRPORT",
  },
  {
    id: "oit",
    label: "Oita, JP",
    code: "OIT",
    description: "Oita Airport",
    type: "AIRPORT",
  },
  {
    id: "oka",
    label: "Naha, JP",
    code: "OKA",
    description: "Naha Airport",
    type: "AIRPORT",
  },
  {
    id: "okc",
    label: "Oklahoma City, US",
    code: "OKC",
    description: "Okc Will Rogers International Airport",
    type: "AIRPORT",
  },
  {
    id: "okd",
    label: "Sapporo-Okadama, JP",
    code: "OKD",
    description: "Okadama Airport",
    type: "AIRPORT",
  },
  {
    id: "oke",
    label: "Okierabu, JP",
    code: "OKE",
    description: "Okinoerabu Airport",
    type: "AIRPORT",
  },
  {
    id: "oki",
    label: "Okinoshima, JP",
    code: "OKI",
    description: "Oki Airport",
    type: "AIRPORT",
  },
  {
    id: "okj",
    label: "Okayama City, JP",
    code: "OKJ",
    description: "Okayama Airport",
    type: "AIRPORT",
  },
  {
    id: "olb",
    label: "Olbia, IT",
    code: "OLB",
    description: "Olbia / Costa Smeralda Airport",
    type: "AIRPORT",
  },
  {
    id: "oma",
    label: "Omaha, US",
    code: "OMA",
    description: "Eppley Airfield",
    type: "AIRPORT",
  },
  {
    id: "ome",
    label: "Nome, US",
    code: "OME",
    description: "Nome Airport",
    type: "AIRPORT",
  },
  {
    id: "ons",
    label: "Onslow, AU",
    code: "ONS",
    description: "Onslow Airport",
    type: "AIRPORT",
  },
  {
    id: "ont",
    label: "Ontario, US",
    code: "ONT",
    description: "Ontario International Airport",
    type: "AIRPORT",
  },
  {
    id: "ool",
    label: "Gold Coast, AU",
    code: "OOL",
    description: "Gold Coast Airport",
    type: "AIRPORT",
  },
  {
    id: "opo",
    label: "Porto, PT",
    code: "OPO",
    description: "Francisco de Sá Carneiro Airport",
    type: "AIRPORT",
  },
  {
    id: "ord",
    label: "Chicago, US",
    code: "ORD",
    description: "Chicago O'Hare International Airport",
    type: "AIRPORT",
  },
  {
    id: "orf",
    label: "Norfolk, US",
    code: "ORF",
    description: "Norfolk International Airport",
    type: "AIRPORT",
  },
  {
    id: "orh",
    label: "Worcester, US",
    code: "ORH",
    description: "Worcester Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "ory",
    label: "Paris, FR",
    code: "ORY",
    description: "Paris-Orly Airport",
    type: "AIRPORT",
    parentMetroCode: "PAR",
  },
  {
    id: "osl",
    label: "Oslo, NO",
    code: "OSL",
    description: "Oslo Gardermoen Airport",
    type: "AIRPORT",
  },
  {
    id: "otp",
    label: "Bucharest, RO",
    code: "OTP",
    description: "Henri Coanda International Airport",
    type: "AIRPORT",
  },
  {
    id: "otz",
    label: "Kotzebue, US",
    code: "OTZ",
    description: "Ralph Wien Memorial Airport",
    type: "AIRPORT",
  },
  {
    id: "oua",
    label: "Ouagadougou, BF",
    code: "OUA",
    description: "Ouagadougou Airport",
    type: "AIRPORT",
  },
  {
    id: "oud",
    label: "Oujda, MA",
    code: "OUD",
    description: "Angads Airport",
    type: "AIRPORT",
  },
  {
    id: "oul",
    label: "Oulu / Oulunsalo, FI",
    code: "OUL",
    description: "Oulu Airport",
    type: "AIRPORT",
  },
  {
    id: "ovd",
    label: "Ranon, ES",
    code: "OVD",
    description: "Asturias Airport",
    type: "AIRPORT",
  },
  {
    id: "oxb",
    label: "Bissau, GW",
    code: "OXB",
    description: "Osvaldo Vieira International Airport",
    type: "AIRPORT",
  },
  {
    id: "ozg",
    label: "Zagora, MA",
    code: "OZG",
    description: "Zagora Airport",
    type: "AIRPORT",
  },
  {
    id: "ozz",
    label: "Ouarzazate, MA",
    code: "OZZ",
    description: "Ouarzazate Airport",
    type: "AIRPORT",
  },
  {
    id: "pae",
    label: "Everett, US",
    code: "PAE",
    description: "Seattle Paine Field International Airport",
    type: "AIRPORT",
  },
  {
    id: "pbi",
    label: "West Palm Beach, US",
    code: "PBI",
    description: "Palm Beach International Airport",
    type: "AIRPORT",
  },
  {
    id: "pbo",
    label: "Paraburdoo, AU",
    code: "PBO",
    description: "Paraburdoo Airport",
    type: "AIRPORT",
  },
  {
    id: "pdl",
    label: "Ponta Delgada, PT",
    code: "PDL",
    description: "João Paulo II Airport",
    type: "AIRPORT",
  },
  {
    id: "pdx",
    label: "Portland, US",
    code: "PDX",
    description: "Portland International Airport",
    type: "AIRPORT",
  },
  {
    id: "peg",
    label: "Perugia, IT",
    code: "PEG",
    description: "Perugia / San Egidio Airport",
    type: "AIRPORT",
  },
  {
    id: "pek",
    label: "Beijing, CN",
    code: "PEK",
    description: "Beijing Capital International Airport",
    type: "AIRPORT",
  },
  {
    id: "pen",
    label: "Penang, MY",
    code: "PEN",
    description: "Penang International Airport",
    type: "AIRPORT",
  },
  {
    id: "per",
    label: "Perth, AU",
    code: "PER",
    description: "Perth International Airport",
    type: "AIRPORT",
  },
  {
    id: "pew",
    label: "Peshawar, PK",
    code: "PEW",
    description: "Peshawar International Airport",
    type: "AIRPORT",
  },
  {
    id: "pfo",
    label: "Paphos, CY",
    code: "PFO",
    description: "Paphos International Airport",
    type: "AIRPORT",
  },
  {
    id: "pgv",
    label: "Greenville, US",
    code: "PGV",
    description: "Pitt–Greenville Airport",
    type: "AIRPORT",
  },
  {
    id: "phc",
    label: "Port Harcourt, NG",
    code: "PHC",
    description: "Port Harcourt International Airport",
    type: "AIRPORT",
  },
  {
    id: "phe",
    label: "Port Hedland, AU",
    code: "PHE",
    description: "Port Hedland International Airport",
    type: "AIRPORT",
  },
  {
    id: "phf",
    label: "Newport News/Williamsburg, US",
    code: "PHF",
    description: "Newport News/Williamsburg International Airport",
    type: "AIRPORT",
  },
  {
    id: "phl",
    label: "Philadelphia, US",
    code: "PHL",
    description: "Philadelphia International Airport",
    type: "AIRPORT",
  },
  {
    id: "phx",
    label: "Phoenix, US",
    code: "PHX",
    description: "Phoenix Sky Harbor International Airport",
    type: "AIRPORT",
  },
  {
    id: "pia",
    label: "Peoria, US",
    code: "PIA",
    description: "General Wayne A. Downing Peoria International Airport",
    type: "AIRPORT",
  },
  {
    id: "pit",
    label: "Pittsburgh, US",
    code: "PIT",
    description: "Pittsburgh International Airport",
    type: "AIRPORT",
  },
  {
    id: "pku",
    label: "Pekanbaru, Sumatra Island, ID",
    code: "PKU",
    description: "Sultan Syarif Kasim Ii (Simpang Tiga) Airport",
    type: "AIRPORT",
  },
  {
    id: "pkx",
    label: "Beijing, CN",
    code: "PKX",
    description: "Beijing Daxing International Airport",
    type: "AIRPORT",
  },
  {
    id: "plo",
    label: "Port Lincoln, AU",
    code: "PLO",
    description: "Port Lincoln Airport",
    type: "AIRPORT",
  },
  {
    id: "pls",
    label: "Providenciales Island, TC",
    code: "PLS",
    description: "Providenciales Airport",
    type: "AIRPORT",
  },
  {
    id: "pmi",
    label: "Palma De Mallorca, ES",
    code: "PMI",
    description: "Palma De Mallorca Airport",
    type: "AIRPORT",
  },
  {
    id: "pmo",
    label: "Palermo, IT",
    code: "PMO",
    description: "Palermo / Punta Raisi Airport",
    type: "AIRPORT",
  },
  {
    id: "pna",
    label: "Pamplona, ES",
    code: "PNA",
    description: "Pamplona Airport",
    type: "AIRPORT",
  },
  {
    id: "pns",
    label: "Pensacola, US",
    code: "PNS",
    description: "Pensacola International Airport",
    type: "AIRPORT",
  },
  {
    id: "pom",
    label: "Port Moresby, PG",
    code: "POM",
    description: "Port Moresby Jacksons International Airport",
    type: "AIRPORT",
  },
  {
    id: "pop",
    label: "Puerto Plata, DO",
    code: "POP",
    description: "Gregorio Luperon International Airport",
    type: "AIRPORT",
  },
  {
    id: "pos",
    label: "Port of Spain, TT",
    code: "POS",
    description: "Piarco International Airport",
    type: "AIRPORT",
  },
  {
    id: "ppg",
    label: "Pago Pago, US",
    code: "PPG",
    description: "Pago Pago International Airport",
    type: "AIRPORT",
  },
  {
    id: "ppt",
    label: "Papeete, PF",
    code: "PPT",
    description: "Faa'a International Airport",
    type: "AIRPORT",
  },
  {
    id: "pqq",
    label: "Port Macquarie, AU",
    code: "PQQ",
    description: "Port Macquarie Airport",
    type: "AIRPORT",
  },
  {
    id: "prg",
    label: "Prague, CZ",
    code: "PRG",
    description: "Václav Havel Airport",
    type: "AIRPORT",
  },
  {
    id: "psa",
    label: "Pisa, IT",
    code: "PSA",
    description: "Pisa / San Giusto - Galileo Galilei International Airport",
    type: "AIRPORT",
  },
  {
    id: "psc",
    label: "Pasco, US",
    code: "PSC",
    description: "Tri-Cities Airport",
    type: "AIRPORT",
  },
  {
    id: "psg",
    label: "Petersburg, US",
    code: "PSG",
    description: "Petersburg James A Johnson Airport",
    type: "AIRPORT",
  },
  {
    id: "psp",
    label: "Palm Springs, US",
    code: "PSP",
    description: "Palm Springs International Airport",
    type: "AIRPORT",
  },
  {
    id: "ptp",
    label: "Pointe-a-Pitre Le Raizet, GP",
    code: "PTP",
    description: "Pointe-a-Pitre Le Raizet",
    type: "AIRPORT",
  },
  {
    id: "pty",
    label: "Tocumen, PA",
    code: "PTY",
    description: "Tocumen International Airport",
    type: "AIRPORT",
  },
  {
    id: "puj",
    label: "Punta Cana, DO",
    code: "PUJ",
    description: "Punta Cana International Airport",
    type: "AIRPORT",
  },
  {
    id: "puw",
    label: "Pullman WA/Moscow ID, US",
    code: "PUW",
    description: "Pullman–Moscow Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "pvd",
    label: "Providence, US",
    code: "PVD",
    description: "Rhode Island Tf Green International Airport",
    type: "AIRPORT",
  },
  {
    id: "pvg",
    label: "Shanghai, CN",
    code: "PVG",
    description: "Shanghai Pudong International Airport",
    type: "AIRPORT",
  },
  {
    id: "pvk",
    label: "Preveza/Lefkada, GR",
    code: "PVK",
    description: "Aktion National Airport",
    type: "AIRPORT",
  },
  {
    id: "pvr",
    label: "Puerto Vallarta, MX",
    code: "PVR",
    description: "Licenciado Gustavo Diaz Ordaz International Airport",
    type: "AIRPORT",
  },
  {
    id: "pvu",
    label: "Provo, US",
    code: "PVU",
    description: "Provo Municipal Airport",
    type: "AIRPORT",
  },
  {
    id: "pwm",
    label: "Portland, US",
    code: "PWM",
    description: "Portland International Jetport Airport",
    type: "AIRPORT",
  },
  {
    id: "pxm",
    label: "Puerto Escondido, MX",
    code: "PXM",
    description: "Puerto Escondido International Airport",
    type: "AIRPORT",
  },
  {
    id: "pzu",
    label: "Port Sudan, SD",
    code: "PZU",
    description: "Port Sudan New International Airport",
    type: "AIRPORT",
  },
  {
    id: "qro",
    label: "Queretaro, MX",
    code: "QRO",
    description: "Queretaro Intercontinental Airport",
    type: "AIRPORT",
  },
  {
    id: "qsr",
    label: "Salerno, IT",
    code: "QSR",
    description: "Salerno / Pontecagnano Airport",
    type: "AIRPORT",
  },
  {
    id: "rai",
    label: "Praia, CV",
    code: "RAI",
    description: "Praia International Airport",
    type: "AIRPORT",
  },
  {
    id: "rak",
    label: "Marrakech, MA",
    code: "RAK",
    description: "Menara Airport",
    type: "AIRPORT",
  },
  {
    id: "rap",
    label: "Rapid City, US",
    code: "RAP",
    description: "Rapid City Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "rar",
    label: "Avarua, CK",
    code: "RAR",
    description: "Rarotonga International Airport",
    type: "AIRPORT",
  },
  {
    id: "rba",
    label: "Rabat, MA",
    code: "RBA",
    description: "Rabat-Sale Airport",
    type: "AIRPORT",
  },
  {
    id: "rdb",
    label: "Red Dog, US",
    code: "RDB",
    description: "Red Dog Airport",
    type: "AIRPORT",
  },
  {
    id: "rdd",
    label: "Redding, US",
    code: "RDD",
    description: "Redding Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "rdm",
    label: "Redmond, US",
    code: "RDM",
    description: "Roberts Field",
    type: "AIRPORT",
  },
  {
    id: "rdu",
    label: "Raleigh/Durham, US",
    code: "RDU",
    description: "Raleigh-Durham International Airport",
    type: "AIRPORT",
  },
  {
    id: "rec",
    label: "Recife, BR",
    code: "REC",
    description: "Guararapes - Gilberto Freyre International Airport",
    type: "AIRPORT",
  },
  {
    id: "reu",
    label: "Reus, ES",
    code: "REU",
    description: "Reus Airport",
    type: "AIRPORT",
  },
  {
    id: "rgn",
    label: "Yangon, MM",
    code: "RGN",
    description: "Yangon International Airport",
    type: "AIRPORT",
  },
  {
    id: "rho",
    label: "Rodes Island, GR",
    code: "RHO",
    description: "Diagoras Airport",
    type: "AIRPORT",
  },
  {
    id: "ric",
    label: "Richmond, US",
    code: "RIC",
    description: "Richmond International Airport",
    type: "AIRPORT",
  },
  {
    id: "ris",
    label: "Rishiri, JP",
    code: "RIS",
    description: "Rishiri Airport",
    type: "AIRPORT",
  },
  {
    id: "rix",
    label: "Riga, LV",
    code: "RIX",
    description: "Riga International Airport",
    type: "AIRPORT",
  },
  {
    id: "rjl",
    label: "Logrono, ES",
    code: "RJL",
    description: "Logroño–Agoncillo Airport",
    type: "AIRPORT",
  },
  {
    id: "rmi",
    label: "Rimini, IT",
    code: "RMI",
    description: "Rimini / Miramare - Federico Fellini International Airport",
    type: "AIRPORT",
  },
  {
    id: "rmu",
    label: "Corvera, ES",
    code: "RMU",
    description: "Región de Murcia International Airport",
    type: "AIRPORT",
  },
  {
    id: "rnj",
    label: "Yoron, JP",
    code: "RNJ",
    description: "Yoron Airport",
    type: "AIRPORT",
  },
  {
    id: "rno",
    label: "Reno, US",
    code: "RNO",
    description: "Reno/Tahoe International Airport",
    type: "AIRPORT",
  },
  {
    id: "roa",
    label: "Roanoke, US",
    code: "ROA",
    description: "Roanoke–Blacksburg Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "rob",
    label: "Monrovia, LR",
    code: "ROB",
    description: "Roberts International Airport",
    type: "AIRPORT",
  },
  {
    id: "roc",
    label: "Rochester, US",
    code: "ROC",
    description: "Frederick Douglass/Greater Rochester International Airport",
    type: "AIRPORT",
  },
  {
    id: "rok",
    label: "Rockhampton, AU",
    code: "ROK",
    description: "Rockhampton Airport",
    type: "AIRPORT",
  },
  {
    id: "ror",
    label: "Babelthuap Island, PW",
    code: "ROR",
    description: "Palau International Airport",
    type: "AIRPORT",
  },
  {
    id: "row",
    label: "Roswell, US",
    code: "ROW",
    description: "Roswell Air Center",
    type: "AIRPORT",
  },
  {
    id: "rsi",
    label: "Hanak, SA",
    code: "RSI",
    description: "Red Sea International Airport",
    type: "AIRPORT",
  },
  {
    id: "rst",
    label: "Rochester, US",
    code: "RST",
    description: "Rochester International Airport",
    type: "AIRPORT",
  },
  {
    id: "rsw",
    label: "Fort Myers, US",
    code: "RSW",
    description: "Southwest Florida International Airport",
    type: "AIRPORT",
  },
  {
    id: "rta",
    label: "Rotuma, FJ",
    code: "RTA",
    description: "Rotuma Airport",
    type: "AIRPORT",
  },
  {
    id: "rtb",
    label: "Roatan Island, HN",
    code: "RTB",
    description: "Juan Manuel Galvez International Airport",
    type: "AIRPORT",
  },
  {
    id: "rtm",
    label: "Rotterdam, NL",
    code: "RTM",
    description: "Rotterdam The Hague Airport",
    type: "AIRPORT",
  },
  {
    id: "ruh",
    label: "Riyadh, SA",
    code: "RUH",
    description: "King Khaled International Airport",
    type: "AIRPORT",
  },
  {
    id: "rvn",
    label: "Rovaniemi, FI",
    code: "RVN",
    description: "Rovaniemi Airport",
    type: "AIRPORT",
  },
  {
    id: "saf",
    label: "Santa Fe, US",
    code: "SAF",
    description: "Santa Fe Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "sal",
    label: "Santa Clara, SV",
    code: "SAL",
    description: "El Salvador International Airport",
    type: "AIRPORT",
  },
  {
    id: "san",
    label: "San Diego, US",
    code: "SAN",
    description: "San Diego International Airport",
    type: "AIRPORT",
  },
  {
    id: "sap",
    label: "La Mesa, HN",
    code: "SAP",
    description: "Ramon Villeda Morales International Airport",
    type: "AIRPORT",
  },
  {
    id: "sat",
    label: "San Antonio, US",
    code: "SAT",
    description: "San Antonio International Airport",
    type: "AIRPORT",
  },
  {
    id: "sav",
    label: "Savannah, US",
    code: "SAV",
    description: "Savannah/Hilton Head International Airport",
    type: "AIRPORT",
  },
  {
    id: "saw",
    label: "Istanbul, TR",
    code: "SAW",
    description: "Sabiha Gokcen International Airport",
    type: "AIRPORT",
  },
  {
    id: "sba",
    label: "Santa Barbara, US",
    code: "SBA",
    description: "Santa Barbara Municipal Airport",
    type: "AIRPORT",
  },
  {
    id: "sbn",
    label: "South Bend, US",
    code: "SBN",
    description: "South Bend International Airport",
    type: "AIRPORT",
  },
  {
    id: "sbp",
    label: "San Luis Obispo, US",
    code: "SBP",
    description: "San Luis Obispo County Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "sbw",
    label: "Sibu, MY",
    code: "SBW",
    description: "Sibu Airport",
    type: "AIRPORT",
  },
  {
    id: "sby",
    label: "Salisbury/Ocean City, US",
    code: "SBY",
    description: "Salisbury–Ocean City–Wicomico Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "scc",
    label: "Deadhorse, US",
    code: "SCC",
    description: "Deadhorse Airport",
    type: "AIRPORT",
  },
  {
    id: "sce",
    label: "State College, US",
    code: "SCE",
    description: "University Park Airport",
    type: "AIRPORT",
  },
  {
    id: "scl",
    label: "Santiago, CL",
    code: "SCL",
    description: "Comodoro Arturo Merino Benitez International Airport",
    type: "AIRPORT",
  },
  {
    id: "scq",
    label: "Santiago de Compostela, ES",
    code: "SCQ",
    description: "Santiago de Compostela Airport",
    type: "AIRPORT",
  },
  {
    id: "scu",
    label: "Santiago, CU",
    code: "SCU",
    description: "Antonio Maceo International Airport",
    type: "AIRPORT",
  },
  {
    id: "sdf",
    label: "Louisville, US",
    code: "SDF",
    description: "Louisville Muhammad Ali International Airport",
    type: "AIRPORT",
  },
  {
    id: "sdj",
    label: "Sendai, JP",
    code: "SDJ",
    description: "Sendai Airport",
    type: "AIRPORT",
  },
  {
    id: "sdk",
    label: "Sandakan, MY",
    code: "SDK",
    description: "Sandakan Airport",
    type: "AIRPORT",
  },
  {
    id: "sdq",
    label: "Santo Domingo, DO",
    code: "SDQ",
    description: "Las Americas International Airport",
    type: "AIRPORT",
  },
  {
    id: "sdr",
    label: "Santander, ES",
    code: "SDR",
    description: "Santander Airport",
    type: "AIRPORT",
  },
  {
    id: "sea",
    label: "Seattle, US",
    code: "SEA",
    description: "Seattle-Tacoma International Airport",
    type: "AIRPORT",
  },
  {
    id: "sez",
    label: "Mahe Island, SC",
    code: "SEZ",
    description: "Seychelles International Airport",
    type: "AIRPORT",
  },
  {
    id: "sfo",
    label: "San Francisco, US",
    code: "SFO",
    description: "San Francisco International Airport",
    type: "AIRPORT",
  },
  {
    id: "sgf",
    label: "Springfield, US",
    code: "SGF",
    description: "Springfield–Branson National Airport",
    type: "AIRPORT",
  },
  {
    id: "sgn",
    label: "Ho Chi Minh City, VN",
    code: "SGN",
    description: "Tan Son Nhat International Airport",
    type: "AIRPORT",
  },
  {
    id: "sgu",
    label: "St. George, US",
    code: "SGU",
    description: "St. George Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "sha",
    label: "Shanghai, CN",
    code: "SHA",
    description: "Shanghai Hongqiao International Airport",
    type: "AIRPORT",
  },
  {
    id: "shb",
    label: "Nakashibetsu, JP",
    code: "SHB",
    description: "Nakashibetsu Airport",
    type: "AIRPORT",
  },
  {
    id: "shd",
    label: "Staunton/Waynesboro, US",
    code: "SHD",
    description: "Shenandoah Valley Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "shj",
    label: "Sharjah, AE",
    code: "SHJ",
    description: "Sharjah International Airport",
    type: "AIRPORT",
  },
  {
    id: "shm",
    label: "Shirahama, JP",
    code: "SHM",
    description: "Nanki Shirahama Airport",
    type: "AIRPORT",
  },
  {
    id: "shv",
    label: "Shreveport, US",
    code: "SHV",
    description: "Shreveport Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "sid",
    label: "Espargos, CV",
    code: "SID",
    description: "Amilcar Cabral International Airport",
    type: "AIRPORT",
  },
  {
    id: "sin",
    label: "Singapore, SG",
    code: "SIN",
    description: "Singapore Changi International Airport",
    type: "AIRPORT",
  },
  {
    id: "sit",
    label: "Sitka, US",
    code: "SIT",
    description: "Sitka Rocky Gutierrez Airport",
    type: "AIRPORT",
  },
  {
    id: "sjc",
    label: "San Jose, US",
    code: "SJC",
    description: "Norman Y Mineta San Jose International Airport",
    type: "AIRPORT",
  },
  {
    id: "sjd",
    label: "San Jose del Cabo, MX",
    code: "SJD",
    description: "Los Cabos International Airport",
    type: "AIRPORT",
  },
  {
    id: "sjo",
    label: "San Jose, CR",
    code: "SJO",
    description: "Juan Santamaria International Airport",
    type: "AIRPORT",
  },
  {
    id: "sjt",
    label: "San Angelo, US",
    code: "SJT",
    description: "San Angelo Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "sju",
    label: "San Juan, US",
    code: "SJU",
    description: "Luis Munoz Marin International Airport",
    type: "AIRPORT",
  },
  {
    id: "skb",
    label: "Basseterre, KN",
    code: "SKB",
    description: "Robert L. Bradshaw International Airport",
    type: "AIRPORT",
  },
  {
    id: "skg",
    label: "Thessaloniki, GR",
    code: "SKG",
    description: "Thessaloniki Macedonia International Airport",
    type: "AIRPORT",
  },
  {
    id: "skt",
    label: "Sialkot, PK",
    code: "SKT",
    description: "Sialkot Airport",
    type: "AIRPORT",
  },
  {
    id: "slc",
    label: "Salt Lake City, US",
    code: "SLC",
    description: "Salt Lake City International Airport",
    type: "AIRPORT",
  },
  {
    id: "sll",
    label: "Salalah, OM",
    code: "SLL",
    description: "Salalah Airport",
    type: "AIRPORT",
  },
  {
    id: "slm",
    label: "Salamanca, ES",
    code: "SLM",
    description: "Salamanca Airport",
    type: "AIRPORT",
  },
  {
    id: "slp",
    label: "San Luis Potosi, MX",
    code: "SLP",
    description: "Ponciano Arriaga International Airport",
    type: "AIRPORT",
  },
  {
    id: "smf",
    label: "Sacramento, US",
    code: "SMF",
    description: "Sacramento International Airport",
    type: "AIRPORT",
  },
  {
    id: "smw",
    label: "Smara, EH",
    code: "SMW",
    description: "Smara Airport",
    type: "AIRPORT",
  },
  {
    id: "smx",
    label: "Santa Maria, US",
    code: "SMX",
    description: "Santa Maria Public Airport",
    type: "AIRPORT",
  },
  {
    id: "sna",
    label: "Santa Ana, US",
    code: "SNA",
    description: "John Wayne/Orange County Airport",
    type: "AIRPORT",
  },
  {
    id: "snu",
    label: "Santa Clara, CU",
    code: "SNU",
    description: "Abel Santamaria Airport",
    type: "AIRPORT",
  },
  {
    id: "sof",
    label: "Sofia, BG",
    code: "SOF",
    description: "Sofia Airport",
    type: "AIRPORT",
  },
  {
    id: "spc",
    label: "Santa Cruz de la Palma, ES",
    code: "SPC",
    description: "La Palma Airport",
    type: "AIRPORT",
  },
  {
    id: "spi",
    label: "Springfield, US",
    code: "SPI",
    description: "Abraham Lincoln Capital Airport",
    type: "AIRPORT",
  },
  {
    id: "sps",
    label: "Wichita Falls, US",
    code: "SPS",
    description: "Wichita Falls Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "spu",
    label: "Split, HR",
    code: "SPU",
    description: "Split Airport",
    type: "AIRPORT",
  },
  {
    id: "srq",
    label: "Sarasota/Bradenton, US",
    code: "SRQ",
    description: "Sarasota/Bradenton International Airport",
    type: "AIRPORT",
  },
  {
    id: "ssg",
    label: "Malabo, GQ",
    code: "SSG",
    description: "Malabo Airport",
    type: "AIRPORT",
  },
  {
    id: "ssh",
    label: "Sharm el-Sheikh, EG",
    code: "SSH",
    description: "Sharm El Sheikh International Airport",
    type: "AIRPORT",
  },
  {
    id: "sti",
    label: "Santiago, DO",
    code: "STI",
    description: "Cibao International Airport",
    type: "AIRPORT",
  },
  {
    id: "stl",
    label: "St Louis, US",
    code: "STL",
    description: "St Louis Lambert International Airport",
    type: "AIRPORT",
  },
  {
    id: "stn",
    label: "London, GB",
    code: "STN",
    description: "London Stansted Airport",
    type: "AIRPORT",
    parentMetroCode: "LON",
  },
  {
    id: "str",
    label: "Stuttgart, DE",
    code: "STR",
    description: "Stuttgart Airport",
    type: "AIRPORT",
  },
  {
    id: "sts",
    label: "Santa Rosa, US",
    code: "STS",
    description: "Charles M Schulz/Sonoma County Airport",
    type: "AIRPORT",
  },
  {
    id: "stt",
    label: "Charlotte Amalie, US",
    code: "STT",
    description: "Cyril E King Airport",
    type: "AIRPORT",
  },
  {
    id: "stx",
    label: "Christiansted, US",
    code: "STX",
    description: "Henry E Rohlsen Airport",
    type: "AIRPORT",
  },
  {
    id: "sub",
    label: "Surabaya, ID",
    code: "SUB",
    description: "Juanda International Airport",
    type: "AIRPORT",
  },
  {
    id: "sun",
    label: "Hailey-Sun Valley, US",
    code: "SUN",
    description: "Friedman Memorial Airport",
    type: "AIRPORT",
  },
  {
    id: "suv",
    label: "Nausori, FJ",
    code: "SUV",
    description: "Nausori International Airport",
    type: "AIRPORT",
  },
  {
    id: "svd",
    label: "Argyle, VC",
    code: "SVD",
    description: "Argyle International Airport",
    type: "AIRPORT",
  },
  {
    id: "svg",
    label: "Stavanger, NO",
    code: "SVG",
    description: "Stavanger Airport Sola",
    type: "AIRPORT",
  },
  {
    id: "svo",
    label: "Moscow, RU",
    code: "SVO",
    description: "Sheremetyevo International Airport",
    type: "AIRPORT",
  },
  {
    id: "svq",
    label: "Sevilla, ES",
    code: "SVQ",
    description: "Sevilla Airport",
    type: "AIRPORT",
  },
  {
    id: "svu",
    label: "Savusavu, FJ",
    code: "SVU",
    description: "Savusavu Airport",
    type: "AIRPORT",
  },
  {
    id: "swo",
    label: "Stillwater, US",
    code: "SWO",
    description: "Stillwater Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "sxb",
    label: "Strasbourg, FR",
    code: "SXB",
    description: "Strasbourg Airport",
    type: "AIRPORT",
  },
  {
    id: "sxm",
    label: "Saint Martin, SX",
    code: "SXM",
    description: "Princess Juliana International Airport",
    type: "AIRPORT",
  },
  {
    id: "syd",
    label: "Sydney, AU",
    code: "SYD",
    description: "Sydney Kingsford Smith International Airport",
    type: "AIRPORT",
  },
  {
    id: "syr",
    label: "Syracuse, US",
    code: "SYR",
    description: "Syracuse Hancock International Airport",
    type: "AIRPORT",
  },
  {
    id: "syz",
    label: "Shiraz, IR",
    code: "SYZ",
    description: "Shiraz Shahid Dastghaib International Airport",
    type: "AIRPORT",
  },
  {
    id: "szg",
    label: "Salzburg, AT",
    code: "SZG",
    description: "Salzburg Airport",
    type: "AIRPORT",
  },
  {
    id: "szx",
    label: "Shenzhen, CN",
    code: "SZX",
    description: "Shenzhen Bao'an International Airport",
    type: "AIRPORT",
  },
  {
    id: "tab",
    label: "Scarborough, TT",
    code: "TAB",
    description: "Tobago-Crown Point Airport",
    type: "AIRPORT",
  },
  {
    id: "tak",
    label: "Takamatsu, JP",
    code: "TAK",
    description: "Takamatsu Airport",
    type: "AIRPORT",
  },
  {
    id: "tam",
    label: "Tampico, MX",
    code: "TAM",
    description: "General Francisco Javier Mina International Airport",
    type: "AIRPORT",
  },
  {
    id: "tao",
    label: "Qingdao, CN",
    code: "TAO",
    description: "Qingdao/Jiaodong Airport",
    type: "AIRPORT",
  },
  {
    id: "tar",
    label: "Taranto, IT",
    code: "TAR",
    description: "Taranto-Grottaglie Airport",
    type: "AIRPORT",
  },
  {
    id: "tas",
    label: "Tashkent, UZ",
    code: "TAS",
    description: "Tashkent International Airport",
    type: "AIRPORT",
  },
  {
    id: "tay",
    label: "Tartu, EE",
    code: "TAY",
    description: "Tartu Airport",
    type: "AIRPORT",
  },
  {
    id: "tbs",
    label: "Tbilisi, GE",
    code: "TBS",
    description: "Tbilisi International Airport",
    type: "AIRPORT",
  },
  {
    id: "tbu",
    label: "Nuku'alofa, TO",
    code: "TBU",
    description: "Fua'amotu International Airport",
    type: "AIRPORT",
  },
  {
    id: "tfn",
    label: "Tenerife Island, ES",
    code: "TFN",
    description: "Tenerife Norte Airport",
    type: "AIRPORT",
  },
  {
    id: "tfs",
    label: "Tenerife Island, ES",
    code: "TFS",
    description: "Tenerife South Airport",
    type: "AIRPORT",
  },
  {
    id: "tfu",
    label: "Tianfu, CN",
    code: "TFU",
    description: "Chengdu/Tianfu Airport",
    type: "AIRPORT",
  },
  {
    id: "tgg",
    label: "Kuala Terengganu, MY",
    code: "TGG",
    description: "Sultan Mahmud Airport",
    type: "AIRPORT",
  },
  {
    id: "tia",
    label: "Tirana, AL",
    code: "TIA",
    description: "Tirana International Airport Mother Teresa",
    type: "AIRPORT",
  },
  {
    id: "tif",
    label: "Taif, SA",
    code: "TIF",
    description: "Taif Airport",
    type: "AIRPORT",
  },
  {
    id: "tij",
    label: "Tijuana, MX",
    code: "TIJ",
    description: "Tijuana International Airport",
    type: "AIRPORT",
  },
  {
    id: "tiv",
    label: "Tivat, ME",
    code: "TIV",
    description: "Tivat Airport",
    type: "AIRPORT",
  },
  {
    id: "tjh",
    label: "Toyooka, JP",
    code: "TJH",
    description: "Tajima Airport",
    type: "AIRPORT",
  },
  {
    id: "tkn",
    label: "Tokunoshima, JP",
    code: "TKN",
    description: "Tokunoshima Airport",
    type: "AIRPORT",
  },
  {
    id: "tks",
    label: "Tokushima, JP",
    code: "TKS",
    description: "Tokushima Airport",
    type: "AIRPORT",
  },
  {
    id: "tku",
    label: "Turku, FI",
    code: "TKU",
    description: "Turku Airport",
    type: "AIRPORT",
  },
  {
    id: "tlh",
    label: "Tallahassee, US",
    code: "TLH",
    description: "Tallahassee International Airport",
    type: "AIRPORT",
  },
  {
    id: "tll",
    label: "Tallinn, EE",
    code: "TLL",
    description: "Tallinn Airport",
    type: "AIRPORT",
  },
  {
    id: "tln",
    label: "Toulon/Hyeres, FR",
    code: "TLN",
    description: "Toulon–Hyères Airport",
    type: "AIRPORT",
  },
  {
    id: "tls",
    label: "Toulouse/Blagnac, FR",
    code: "TLS",
    description: "Toulouse-Blagnac Airport",
    type: "AIRPORT",
  },
  {
    id: "tlv",
    label: "Tel Aviv, IL",
    code: "TLV",
    description: "Ben Gurion International Airport",
    type: "AIRPORT",
  },
  {
    id: "tmp",
    label: "Tampere, FI",
    code: "TMP",
    description: "Tampere–Pirkkala Airport",
    type: "AIRPORT",
  },
  {
    id: "tmw",
    label: "Tamworth, AU",
    code: "TMW",
    description: "Tamworth Airport",
    type: "AIRPORT",
  },
  {
    id: "tne",
    label: "Tanegashima, JP",
    code: "TNE",
    description: "New Tanegashima Airport",
    type: "AIRPORT",
  },
  {
    id: "tng",
    label: "Tangier, MA",
    code: "TNG",
    description: "Ibn Batouta Airport",
    type: "AIRPORT",
  },
  {
    id: "tos",
    label: "Tromsø, NO",
    code: "TOS",
    description: "Tromsø Airport",
    type: "AIRPORT",
  },
  {
    id: "tpa",
    label: "Tampa, US",
    code: "TPA",
    description: "Tampa International Airport",
    type: "AIRPORT",
  },
  {
    id: "tpe",
    label: "Taipei, TW",
    code: "TPE",
    description: "Taiwan Taoyuan International Airport",
    type: "AIRPORT",
  },
  {
    id: "tqo",
    label: "Tulum, MX",
    code: "TQO",
    description: "Felipe Carrillo Puerto International Airport",
    type: "AIRPORT",
  },
  {
    id: "tra",
    label: "Tarama, JP",
    code: "TRA",
    description: "Tarama Airport",
    type: "AIRPORT",
  },
  {
    id: "trc",
    label: "Torreon, MX",
    code: "TRC",
    description: "Francisco Sarabia International Airport",
    type: "AIRPORT",
  },
  {
    id: "trd",
    label: "Trondheim, NO",
    code: "TRD",
    description: "Trondheim Airport, Værnes",
    type: "AIRPORT",
  },
  {
    id: "tri",
    label: "Bristol/Johnson/Kingsp, US",
    code: "TRI",
    description: "Tri-Cities Airport",
    type: "AIRPORT",
  },
  {
    id: "trn",
    label: "Torino, IT",
    code: "TRN",
    description: "Torino / Caselle International Airport",
    type: "AIRPORT",
  },
  {
    id: "trv",
    label: "Trivandrum, IN",
    code: "TRV",
    description: "Trivandrum International Airport",
    type: "AIRPORT",
  },
  {
    id: "trw",
    label: "Tarawa, KI",
    code: "TRW",
    description: "Bonriki International Airport",
    type: "AIRPORT",
  },
  {
    id: "trz",
    label: "Tiruchirappally, IN",
    code: "TRZ",
    description: "Tiruchirapally Civil Airport Airport",
    type: "AIRPORT",
  },
  {
    id: "tsa",
    label: "Taipei City, TW",
    code: "TSA",
    description: "Taipei Songshan Airport",
    type: "AIRPORT",
  },
  {
    id: "tsn",
    label: "Tianjin, CN",
    code: "TSN",
    description: "Tianjin Binhai International Airport",
    type: "AIRPORT",
  },
  {
    id: "tsv",
    label: "Townsville, AU",
    code: "TSV",
    description: "Townsville Airport",
    type: "AIRPORT",
  },
  {
    id: "tta",
    label: "Tan Tan, MA",
    code: "TTA",
    description: "Tan Tan Airport",
    type: "AIRPORT",
  },
  {
    id: "ttu",
    label: "Tetouan, MA",
    code: "TTU",
    description: "Saniat Rmel Airport",
    type: "AIRPORT",
  },
  {
    id: "tul",
    label: "Tulsa, US",
    code: "TUL",
    description: "Tulsa International Airport",
    type: "AIRPORT",
  },
  {
    id: "tun",
    label: "Tunis, TN",
    code: "TUN",
    description: "Tunis Carthage International Airport",
    type: "AIRPORT",
  },
  {
    id: "tus",
    label: "Tucson, US",
    code: "TUS",
    description: "Tucson International Airport",
    type: "AIRPORT",
  },
  {
    id: "tuu",
    label: "Tabuk, SA",
    code: "TUU",
    description: "Tabuk Airport",
    type: "AIRPORT",
  },
  {
    id: "tvc",
    label: "Traverse City, US",
    code: "TVC",
    description: "Cherry Capital Airport",
    type: "AIRPORT",
  },
  {
    id: "tvu",
    label: "Matei, FJ",
    code: "TVU",
    description: "Matei Airport",
    type: "AIRPORT",
  },
  {
    id: "twu",
    label: "Tawau, MY",
    code: "TWU",
    description: "Tawau Airport",
    type: "AIRPORT",
  },
  {
    id: "txk",
    label: "Texarkana, US",
    code: "TXK",
    description: "Texarkana Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "tyr",
    label: "Tyler, US",
    code: "TYR",
    description: "Tyler Pounds Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "tys",
    label: "Knoxville, US",
    code: "TYS",
    description: "Mc Ghee Tyson Airport",
    type: "AIRPORT",
  },
  {
    id: "tzx",
    label: "Trabzon, TR",
    code: "TZX",
    description: "Trabzon International Airport",
    type: "AIRPORT",
  },
  {
    id: "uar",
    label: "Bouarfa, MA",
    code: "UAR",
    description: "Bouarfa Airport",
    type: "AIRPORT",
  },
  {
    id: "ubj",
    label: "Ube, JP",
    code: "UBJ",
    description: "Yamaguchi Ube Airport",
    type: "AIRPORT",
  },
  {
    id: "ueo",
    label: "Kume Jima, JP",
    code: "UEO",
    description: "Kumejima Airport",
    type: "AIRPORT",
  },
  {
    id: "uio",
    label: "Quito, EC",
    code: "UIO",
    description: "Nuevo Aeropuerto Internacional Mariscal Sucre",
    type: "AIRPORT",
  },
  {
    id: "ulh",
    label: "Al-Ula, SA",
    code: "ULH",
    description: "Al-Ula International Airport",
    type: "AIRPORT",
  },
  {
    id: "ume",
    label: "Umea, SE",
    code: "UME",
    description: "Umeå Airport",
    type: "AIRPORT",
  },
  {
    id: "upg",
    label: "Ujung Pandang-Celebes Island, ID",
    code: "UPG",
    description: "Hasanuddin International Airport",
    type: "AIRPORT",
  },
  {
    id: "urc",
    label: "Urumqi, CN",
    code: "URC",
    description: "Urumqi Diwopu International Airport",
    type: "AIRPORT",
  },
  {
    id: "ure",
    label: "Kuressaare, EE",
    code: "URE",
    description: "Kuressaare Airport",
    type: "AIRPORT",
  },
  {
    id: "uvf",
    label: "Vieux Fort, LC",
    code: "UVF",
    description: "Hewanorra International Airport",
    type: "AIRPORT",
  },
  {
    id: "vaa",
    label: "Vaasa, FI",
    code: "VAA",
    description: "Vaasa Airport",
    type: "AIRPORT",
  },
  {
    id: "vav",
    label: "Vava'u Island, TO",
    code: "VAV",
    description: "Vava'u International Airport",
    type: "AIRPORT",
  },
  {
    id: "vbv",
    label: "Vanua Balavu, FJ",
    code: "VBV",
    description: "Vanua Balavu Airport",
    type: "AIRPORT",
  },
  {
    id: "vby",
    label: "Visby, SE",
    code: "VBY",
    description: "Visby Airport",
    type: "AIRPORT",
  },
  {
    id: "vce",
    label: "Venezia, IT",
    code: "VCE",
    description: "Venezia / Tessera -  Marco Polo Airport",
    type: "AIRPORT",
  },
  {
    id: "ver",
    label: "Veracruz, MX",
    code: "VER",
    description: "Veracruz International Airport",
    type: "AIRPORT",
  },
  {
    id: "vgo",
    label: "Vigo, ES",
    code: "VGO",
    description: "Vigo Airport",
    type: "AIRPORT",
  },
  {
    id: "vie",
    label: "Vienna, AT",
    code: "VIE",
    description: "Vienna International Airport",
    type: "AIRPORT",
  },
  {
    id: "vil",
    label: "Dakhla, EH",
    code: "VIL",
    description: "Dakhla Airport",
    type: "AIRPORT",
  },
  {
    id: "vit",
    label: "Vitoria, ES",
    code: "VIT",
    description: "Vitoria Airport",
    type: "AIRPORT",
  },
  {
    id: "vlc",
    label: "Valencia, ES",
    code: "VLC",
    description: "Valencia Airport",
    type: "AIRPORT",
  },
  {
    id: "vli",
    label: "Port Vila, VU",
    code: "VLI",
    description: "Port Vila Bauerfield Airport",
    type: "AIRPORT",
  },
  {
    id: "vll",
    label: "Valladolid, ES",
    code: "VLL",
    description: "Valladolid Airport",
    type: "AIRPORT",
  },
  {
    id: "vno",
    label: "Vilnius, LT",
    code: "VNO",
    description: "Vilnius International Airport",
    type: "AIRPORT",
  },
  {
    id: "vps",
    label: "Valparaiso/Destin-Ft Walton Beach, US",
    code: "VPS",
    description: "Eglin Afb/Destin-Ft Walton Beach Airport",
    type: "AIRPORT",
  },
  {
    id: "vra",
    label: "Varadero, CU",
    code: "VRA",
    description: "Juan Gualberto Gomez International Airport",
    type: "AIRPORT",
  },
  {
    id: "vrb",
    label: "Vero Beach, US",
    code: "VRB",
    description: "Vero Beach Regional Airport",
    type: "AIRPORT",
  },
  {
    id: "vrn",
    label: "Verona, IT",
    code: "VRN",
    description: "Verona / Villafranca Airport",
    type: "AIRPORT",
  },
  {
    id: "waw",
    label: "Warsaw, PL",
    code: "WAW",
    description: "Warsaw Chopin Airport",
    type: "AIRPORT",
  },
  {
    id: "wei",
    label: "Weipa, AU",
    code: "WEI",
    description: "Weipa Airport",
    type: "AIRPORT",
  },
  {
    id: "wga",
    label: "Wagga Wagga, AU",
    code: "WGA",
    description: "Wagga Wagga Airport",
    type: "AIRPORT",
  },
  {
    id: "wge",
    label: "Walgett, AU",
    code: "WGE",
    description: "Walgett Airport",
    type: "AIRPORT",
  },
  {
    id: "wle",
    label: "Miles, AU",
    code: "WLE",
    description: "Miles Airport",
    type: "AIRPORT",
  },
  {
    id: "wlg",
    label: "Wellington, NZ",
    code: "WLG",
    description: "Wellington International Airport",
    type: "AIRPORT",
  },
  {
    id: "wnz",
    label: "Wenzhou, CN",
    code: "WNZ",
    description: "Wenzhou Yongqiang Airport",
    type: "AIRPORT",
  },
  {
    id: "wrg",
    label: "Wrangell, US",
    code: "WRG",
    description: "Wrangell Airport",
    type: "AIRPORT",
  },
  {
    id: "wtb",
    label: "Toowoomba, AU",
    code: "WTB",
    description: "Toowoomba Wellcamp Airport",
    type: "AIRPORT",
  },
  {
    id: "wuh",
    label: "Wuhan, CN",
    code: "WUH",
    description: "Wuhan Tianhe International Airport",
    type: "AIRPORT",
  },
  {
    id: "wya",
    label: "Whyalla, AU",
    code: "WYA",
    description: "Whyalla Airport",
    type: "AIRPORT",
  },
  {
    id: "xch",
    label: "Christmas Island, CX",
    code: "XCH",
    description: "Christmas Island Airport",
    type: "AIRPORT",
  },
  {
    id: "xiy",
    label: "Xianyang, CN",
    code: "XIY",
    description: "Xi'an Xianyang International Airport",
    type: "AIRPORT",
  },
  {
    id: "xmn",
    label: "Xiamen, CN",
    code: "XMN",
    description: "Xiamen Gaoqi International Airport",
    type: "AIRPORT",
  },
  {
    id: "xna",
    label: "Fayetteville/Springdale/Rogers, US",
    code: "XNA",
    description: "Northwest Arkansas Ntl Airport",
    type: "AIRPORT",
  },
  {
    id: "xpl",
    label: "Comayagua, HN",
    code: "XPL",
    description: "Comayagua-Palmerola International Airport",
    type: "AIRPORT",
  },
  {
    id: "xry",
    label: "Jerez de la Forntera, ES",
    code: "XRY",
    description: "Jerez Airport",
    type: "AIRPORT",
  },
  {
    id: "xsc",
    label: "South Caicos, TC",
    code: "XSC",
    description: "South Caicos Airport",
    type: "AIRPORT",
  },
  {
    id: "yak",
    label: "Yakutat, US",
    code: "YAK",
    description: "Yakutat Airport",
    type: "AIRPORT",
  },
  {
    id: "yeg",
    label: "Edmonton, CA",
    code: "YEG",
    description: "Edmonton International Airport",
    type: "AIRPORT",
  },
  {
    id: "yhz",
    label: "Halifax, CA",
    code: "YHZ",
    description: "Halifax Robert L. Stanfield International Airport",
    type: "AIRPORT",
  },
  {
    id: "yia",
    label: "Yogyakarta, Java Island, ID",
    code: "YIA",
    description: "Yogyakarta International Airport",
    type: "AIRPORT",
  },
  {
    id: "ykm",
    label: "Yakima, US",
    code: "YKM",
    description: "Yakima Air Terminal",
    type: "AIRPORT",
  },
  {
    id: "ylw",
    label: "Kelowna, CA",
    code: "YLW",
    description: "Kelowna International Airport",
    type: "AIRPORT",
  },
  {
    id: "ynb",
    label: "Yanbu al Bahr, SA",
    code: "YNB",
    description: "Yenbo Airport",
    type: "AIRPORT",
  },
  {
    id: "yqb",
    label: "Quebec, CA",
    code: "YQB",
    description: "Québec City Jean Lesage International Airport",
    type: "AIRPORT",
  },
  {
    id: "yul",
    label: "Dorval, CA",
    code: "YUL",
    description: "Montréal-Pierre Elliott Trudeau International Airport",
    type: "AIRPORT",
  },
  {
    id: "yum",
    label: "Yuma, US",
    code: "YUM",
    description: "Yuma International Airport",
    type: "AIRPORT",
  },
  {
    id: "yvr",
    label: "Richmond, CA",
    code: "YVR",
    description: "Vancouver International Airport",
    type: "AIRPORT",
  },
  {
    id: "yxy",
    label: "Whitehorse, CA",
    code: "YXY",
    description: "Erik Nielsen Whitehorse International Airport",
    type: "AIRPORT",
  },
  {
    id: "yyc",
    label: "Calgary, CA",
    code: "YYC",
    description: "Calgary International Airport",
    type: "AIRPORT",
  },
  {
    id: "yyj",
    label: "Victoria, CA",
    code: "YYJ",
    description: "Victoria International Airport",
    type: "AIRPORT",
  },
  {
    id: "yyz",
    label: "Mississauga, CA",
    code: "YYZ",
    description: "Toronto Pearson International Airport",
    type: "AIRPORT",
  },
  {
    id: "zag",
    label: "Zagreb, HR",
    code: "ZAG",
    description: "Zagreb Airport",
    type: "AIRPORT",
  },
  {
    id: "zaz",
    label: "Zaragoza, ES",
    code: "ZAZ",
    description: "Zaragoza Airport",
    type: "AIRPORT",
  },
  {
    id: "zcl",
    label: "Zacatecas, MX",
    code: "ZCL",
    description: "Zacatecas International Airport",
    type: "AIRPORT",
  },
  {
    id: "zih",
    label: "Ixtapa, MX",
    code: "ZIH",
    description: "Ixtapa Zihuatanejo International Airport",
    type: "AIRPORT",
  },
  {
    id: "zlo",
    label: "Manzanillo, MX",
    code: "ZLO",
    description: "Playa De Oro International Airport",
    type: "AIRPORT",
  },
  {
    id: "zne",
    label: "Newman, AU",
    code: "ZNE",
    description: "Newman Airport",
    type: "AIRPORT",
  },
  {
    id: "znz",
    label: "Kiembi Samaki, TZ",
    code: "ZNZ",
    description: "Zanzibar Airport",
    type: "AIRPORT",
  },
  {
    id: "zqn",
    label: "Queenstown, NZ",
    code: "ZQN",
    description: "Queenstown International Airport",
    type: "AIRPORT",
  },
  {
    id: "zrh",
    label: "Zurich, CH",
    code: "ZRH",
    description: "Zurich Airport",
    type: "AIRPORT",
  },
  {
    id: "zth",
    label: "Zakynthos Island, GR",
    code: "ZTH",
    description: "Dionysios Solomos Airport",
    type: "AIRPORT",
  },
  {
    id: "lon",
    label: "London, GB",
    code: "LON",
    description: "All London Area Airports",
    type: "AREA",
  },
  {
    id: "nyc",
    label: "New York, US",
    code: "NYC",
    description: "All New York Area Airports",
    type: "AREA",
  },
  {
    id: "osa",
    label: "Osaka, JP",
    code: "OSA",
    description: "All Osaka Area Airports",
    type: "AREA",
  },
  {
    id: "par",
    label: "Paris, FR",
    code: "PAR",
    description: "All Paris Area Airports",
    type: "AREA",
  },
  {
    id: "sel",
    label: "Seoul, KR",
    code: "SEL",
    description: "All Seoul Area Airports",
    type: "AREA",
  },
  {
    id: "tyo",
    label: "Tokyo, JP",
    code: "TYO",
    description: "All Tokyo Area Airports",
    type: "AREA",
  },
  {
    id: "was",
    label: "Washington, US",
    code: "WAS",
    description: "All Washington Area Airports",
    type: "AREA",
  },
];

const constituentAirportsByMetroCode = destinationCatalog.reduce<
  Record<string, string[]>
>((membersByMetroCode, option) => {
  if (option.type === "AIRPORT" && option.code && option.parentMetroCode) {
    (membersByMetroCode[option.parentMetroCode] ??= []).push(option.code);
  }
  return membersByMetroCode;
}, {});

export const destinationOptions: HeroComboBoxOption[] = destinationCatalog.map(
  (option) =>
    option.type === "AREA" && option.code
      ? {
          ...option,
          constituentAirports:
            constituentAirportsByMetroCode[option.code] ?? [],
        }
      : option,
);

export const originOptions: HeroComboBoxOption[] = [
  {
    id: "any",
    label: "Anywhere",
    code: "ANY",
    description: "Any departure city",
  },
  ...destinationOptions,
];
